

  import React, { useState, useRef, useEffect, useCallback } from 'react';
  import api from '../api/api';
  import bgImage from '../assets/bg.png'; // <--- Yeh line yahan add karni hai
 import Congratulations from '../components/congratulation';
import Participated from '../components/participated';
import confetti from 'canvas-confetti';
 const DESIGN_WIDTH = 440;
const DESIGN_HEIGHT = 726;
const DESIGN_WHEEL_SIZE = 210;
 
  const wheelColors = [
  '#BF0301', '#030101', 
  '#BF0301', '#030101', 
  '#BF0301', '#030101', 
  '#BF0301', '#030101', 
  '#BF0301', '#030101',   
];

  const DEFAULT_SEGMENTS_MALE = [
    { label: '10% OFF',   winWeight: 25, categoryId: 'test1', categoryName: 'Discount', subCategory: 'All Items' },
    { label: 'FREE ITEM', winWeight: 15, categoryId: 'test2', categoryName: 'Gift',     subCategory: 'Selected Items' },
    { label: '5% OFF',    winWeight: 30, categoryId: 'test3', categoryName: 'Discount', subCategory: 'Mens Shoes' },
    { label: 'TRY AGAIN', winWeight: 30, categoryId: 'test4', categoryName: 'No Win',   subCategory: '' },
  ];

  const DEFAULT_SEGMENTS_FEMALE = [
    { label: '15% OFF',   winWeight: 25, categoryId: 'test5', categoryName: 'Discount', subCategory: 'All Items' },
    { label: 'FREE ITEM', winWeight: 15, categoryId: 'test6', categoryName: 'Gift',     subCategory: 'Selected Items' },
    { label: '10% OFF',   winWeight: 30, categoryId: 'test7', categoryName: 'Discount', subCategory: 'Ladies Shoes' },
    { label: 'TRY AGAIN', winWeight: 30, categoryId: 'test8', categoryName: 'No Win',   subCategory: '' },
  ];

  export default function SpinWheel() {
    const [segments, setSegments]               = useState([]);
    const [playerName, setPlayerName]           = useState('');
    const [countryCode, setCountryCode]         = useState('+92');
    const [mobileNumber, setMobileNumber]       = useState('');
    const [gender, setGender]                   = useState('male');
    const [isSpinning, setIsSpinning]           = useState(false);
    const [result, setResult]                   = useState(null);
    const [showCongrats, setShowCongrats]       = useState(false);
    const [winningCode, setWinningCode]         = useState('');
const [wheelSize] = useState(DESIGN_WHEEL_SIZE);
const [stageScale, setStageScale] = useState(1);
    const [errorMsg, setErrorMsg]               = useState('');
    const [isLoading, setIsLoading]             = useState(true);
    
    // NEW STATE FOR ALREADY USED POPUP
    const [showAlreadyUsedPopup, setShowAlreadyUsedPopup] = useState(false);
    // NEW STATE FOR PREVIOUS WIN DATA
    const [previousWinData, setPreviousWinData] = useState(null);
    const [showBlockedPopup, setShowBlockedPopup] = useState(false);
    const params = new URLSearchParams(window.location.search);
    const storeId = params.get('storeId');

    const currentAngleRef    = useRef(0);
const rafRef             = useRef(null);
const canvasRef          = useRef(null);
const stageRef           = useRef(null);
const autoResetTimerRef  = useRef(null);
const errorTimeoutRef    = useRef(null);
const segmentsRef        = useRef([]);

    // Voice / sound helpers
    const synthRef           = useRef(typeof window !== 'undefined' ? window.speechSynthesis : null);
    const femaleVoiceRef     = useRef(null);
    const voiceInitTimerRef  = useRef(null);
    const audioCtxRef        = useRef(null);
    const lastTickTimeRef    = useRef(0);

    const API_BASE = api ? api.defaults.baseURL || '' : '';

    // ─── helpers ────────────────────────────────────────────────────────────────
    const showError = (message) => {
      if (errorTimeoutRef.current) clearTimeout(errorTimeoutRef.current);
      setErrorMsg(message);
      errorTimeoutRef.current = setTimeout(() => setErrorMsg(''), 7000);
    };

    const digitsOnly = (s) => (s || '').replace(/\D/g, '');

    const getApiErrorMessage = (err, fallback = 'Network error. Please check your connection and try again.') => {
      return (
        err?.response?.data?.message ||
        err?.response?.data?.error   ||
        err?.message                 ||
        fallback
      );
    };

const triggerConfetti = () => {
  const end = Date.now() + 2500; // Sirf 2.5 sec tak particles spawn honge

  const colors = [
    '#FFD700',
    '#FDB931',
    '#D4AF37',
    '#FFF8DC',
    '#E6C200',
    '#DAA520',
  ];

  (function frame() {
    confetti({
      particleCount: 4,

      // Top se neeche
      angle: 270,

      spread: 70,

      // Hamesha screen ke upper edge se
      origin: {
        x: Math.random(),
        y: -0.05,
      },

      colors,

      // Thori fast falling
      gravity: 0.18,

      // Natural halka sway
      drift: Math.random() * 0.3 - 0.15,

      // Mixed particle sizes
      scalar: Math.random() * 0.35 + 0.8,

      // Particle enough time tak fall kare,
      // phir automatically disappear ho jaye
      ticks: 180,
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
};


    // ─── voice helpers ─────────────────────────────────────────────────────────
    const pickFemaleVoice = useCallback(() => {
      try {
        const synth = synthRef.current;
        if (!synth) return null;
        const voices = synth.getVoices?.() || [];
        if (!voices.length) return null;

        const preferred = voices.find(v => /female|zira|susan|samantha|victoria|karen|moira|tessa|allison|ava|veena|laila/i.test(v.name || ''));
        if (preferred) return preferred;

        const enVoice = voices.find(v => /^en(-|_)?/i.test(v.lang || '') && !/male/i.test(v.name || ''));
        if (enVoice) return enVoice;

        return voices[0] || null;
      } catch {
        return null;
      }
    }, []);

    const initVoices = useCallback(() => {
      if (typeof window === 'undefined') return;
      const synth = synthRef.current;
      if (!synth) return;
      femaleVoiceRef.current = pickFemaleVoice();
    }, [pickFemaleVoice]);

    const speakText = useCallback((text, { rate = 1, pitch = 1.15, volume = 1 } = {}) => {
      try {
        if (typeof window === 'undefined') return;
        const synth = synthRef.current;
        if (!synth || !('SpeechSynthesisUtterance' in window)) return;

        synth.cancel();
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.rate = rate;
        utterance.pitch = pitch;
        utterance.volume = volume;
        utterance.lang = 'en-US';
        if (!femaleVoiceRef.current) femaleVoiceRef.current = pickFemaleVoice();
        if (femaleVoiceRef.current) utterance.voice = femaleVoiceRef.current;
        synth.speak(utterance);
      } catch {
        // silent fail
      }
    }, [pickFemaleVoice]);

    const stopSpeech = useCallback(() => {
      try {
        if (typeof window === 'undefined') return;
        const synth = synthRef.current;
        if (synth) synth.cancel();
      } catch {
        // silent fail
      }
    }, []);

    const playTickSound = useCallback((frequency = 12000, duration = 0.03, gainValue = 8) => {
      try {
        if (typeof window === 'undefined') return;
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return;

        if (!audioCtxRef.current) {
          audioCtxRef.current = new AudioContextClass();
        }

        const ctx = audioCtxRef.current;
        if (ctx.state === 'suspended') {
          ctx.resume?.();
        }

        const oscillator = ctx.createOscillator();
        const gainNode = ctx.createGain();

        oscillator.type = 'square';
        oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);

        gainNode.gain.setValueAtTime(gainValue, ctx.currentTime);
        gainNode.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration);

        oscillator.connect(gainNode);
        gainNode.connect(ctx.destination);

        oscillator.start();
        oscillator.stop(ctx.currentTime + duration);
      } catch {
        // silent fail
      }
    }, []);

    useEffect(() => {
      initVoices();
      if (typeof window !== 'undefined') {
        const synth = synthRef.current;
        if (synth && 'onvoiceschanged' in synth) {
          synth.onvoiceschanged = initVoices;
        } else {
          voiceInitTimerRef.current = setTimeout(initVoices, 500);
        }
      }

      return () => {
        if (voiceInitTimerRef.current) clearTimeout(voiceInitTimerRef.current);
        stopSpeech();
      };
    }, [initVoices, stopSpeech]);

   // ─────────────────────────────────────────────
// RESPONSIVE ARTBOARD SCALE
// ─────────────────────────────────────────────
useEffect(() => {
  const updateStageScale = () => {
    const stage = stageRef.current;
    if (!stage) return;

    const availableWidth = stage.clientWidth;
    const availableHeight = stage.clientHeight;

    const widthScale = availableWidth / DESIGN_WIDTH;
    const heightScale = availableHeight / DESIGN_HEIGHT;

    const nextScale = Math.min(
      widthScale,
      heightScale,
      1
    );

    setStageScale(nextScale);
  };

  updateStageScale();

  const stage = stageRef.current;

  let resizeObserver;

  if (stage && typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(() => {
      updateStageScale();
    });

    resizeObserver.observe(stage);
  }

  window.addEventListener('resize', updateStageScale);
  window.visualViewport?.addEventListener('resize', updateStageScale);

  return () => {
    resizeObserver?.disconnect();
    window.removeEventListener('resize', updateStageScale);
    window.visualViewport?.removeEventListener('resize', updateStageScale);
  };
}, []);

    // ─── draw wheel ─────────────────────────────────────────────────────────────
  const drawWheel = useCallback((segs, rotationDeg = 0) => {
    const canvas = canvasRef.current;
      if (!canvas || segs.length === 0) return;

  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  // =====================================================
  // HIGH RESOLUTION CANVAS
  // =====================================================

  // Screen/device pixel ratio
  const dpr = Math.min(window.devicePixelRatio || 1, 8);

  // Wheel ka actual visible size
  const size = wheelSize;

  // Internal high-resolution pixel size
  const pixelSize = Math.round(size * dpr);

  // Canvas ki internal resolution high karo
  if (canvas.width !== pixelSize || canvas.height !== pixelSize) {
    canvas.width = pixelSize;
    canvas.height = pixelSize;
  }

  // Canvas ka visible size same rakho
  canvas.style.width = `${size}px`;
  canvas.style.height = `${size}px`;

  // Drawing ko DPR ke according scale karo
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  const center = size / 2;
  const radius = center - 1;
  const SA = (2 * Math.PI) / segs.length;
      ctx.clearRect(0, 0, size, size);
      ctx.save();
      ctx.translate(center, center);
      ctx.rotate((rotationDeg * Math.PI) / 180);
      ctx.translate(-center, -center);

      segs.forEach((seg, i) => {
        const sa  = i * SA - Math.PI / 2;
        const ea  = sa + SA;
        const bg  = wheelColors[i % wheelColors.length];
        const ma  = sa + SA / 2;

        ctx.beginPath();
        ctx.moveTo(center, center);
        ctx.arc(center, center, radius, sa, ea);
        ctx.closePath();
        ctx.fillStyle = bg;
        ctx.fill();

        const g = ctx.createRadialGradient(center, center, radius * 0.08, center, center, radius);
        if (bg === '#FFFFFF') {
          g.addColorStop(0,    'rgba(255,255,255,0.92)');
          g.addColorStop(0.65, 'rgba(235,240,252,0.38)');
          g.addColorStop(1,    'rgba(190,205,235,0.15)');
        } else {
          g.addColorStop(0,    'rgba(255,255,255,0.30)');
          g.addColorStop(0.55, 'rgba(255,255,255,0)');
          g.addColorStop(1,    'rgba(0,0,0,0.18)');
        }
        ctx.beginPath();
        ctx.moveTo(center, center);
        ctx.arc(center, center, radius, sa, ea);
        ctx.closePath();
        ctx.fillStyle = g;
        ctx.fill();

        ctx.beginPath();
        ctx.moveTo(center, center);
        ctx.lineTo(center + radius * Math.cos(sa), center + radius * Math.sin(sa));
        ctx.strokeStyle = '#F1DA8B';
        ctx.lineWidth   = 4;
        ctx.stroke();

        const isW = bg === '#FFFFFF';
        ctx.save();
        ctx.translate(
          center + Math.cos(ma) * radius * 0.65,
          center + Math.sin(ma) * radius * 0.65
        );
        ctx.rotate(ma);
  const fontSize = size > 260 ? 18 : 14;

  ctx.font = `900 ${fontSize}px "Century Gothic", "Arial Black", Arial, sans-serif`;

        ctx.fillStyle   = isW ? '#111122' : '#FFFFFF';
        ctx.textAlign   = 'center';
        ctx.textBaseline = 'middle';

        if (!isW) {
          ctx.shadowColor   = 'rgba(0,0,0,0.6)';
          ctx.shadowBlur    = 4;
          ctx.shadowOffsetX = 0;
          ctx.shadowOffsetY = 1;
        }

        // TEXT OVERFLOW FIX ADDED HERE (maxWidth as 4th parameter)
        const maxTextWidth = radius * 0.70;
        ctx.fillText(seg.label, 0, 0, maxTextWidth);
        ctx.restore();
      });

    ctx.restore();
  }, [wheelSize]);
    useEffect(() => {
      if (segments.length) {
        segmentsRef.current = segments;
        drawWheel(segments, currentAngleRef.current);
      }
  }, [segments, wheelSize, drawWheel]);
    // ─── fetch products filtered by gender ──────────────────────────────────────
    const fetchData = useCallback(async (currentGender) => {
      setIsLoading(true);
      try {
        const res = await api.get(`${API_BASE}/api/products`, {
          params: { gender: currentGender }
        });

        const active = Array.isArray(res.data)
          ? res.data.filter(p => p.addInSpin === true)
          : [];

        if (active.length > 0) {
          const mapped = active.map(p => {
            const cfg = p.discounts?.length ? p.discounts[0] : null;
            return {
              label:        cfg ? cfg.label             : 'Try Again',
              winWeight:    cfg ? Number(cfg.winWeight)  : 0,
              categoryId:   p.id,
              categoryName: p.category    || '',
              subCategory:  p.subCategory || '',
              gender:       p.gender      || currentGender,
            };
          });
          setSegments([...mapped].sort(() => Math.random() - 0.5));
        } else {
          const fallback = currentGender === 'female'
            ? DEFAULT_SEGMENTS_FEMALE
            : DEFAULT_SEGMENTS_MALE;
          setSegments([...fallback]);
        }

      } catch {
        const fallback = currentGender === 'female'
          ? DEFAULT_SEGMENTS_FEMALE
          : DEFAULT_SEGMENTS_MALE;
        setSegments([...fallback]);
        showError('Could not load live data. Demo mode active.');
      } finally {
        setIsLoading(false);
      }
    }, [API_BASE]);

    useEffect(() => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      stopSpeech();
      setIsSpinning(false);
      setShowCongrats(false);
      setResult(null);
      setWinningCode('');
      currentAngleRef.current = 0;
      fetchData(gender);
    }, [gender, fetchData, stopSpeech]);

    const resetWheelVisuals = () => {
      setShowCongrats(false);
      setResult(null);
      setWinningCode('');
      if (autoResetTimerRef.current) clearTimeout(autoResetTimerRef.current);
      stopSpeech();
    };

    const canSpin = segments.length > 0 && !isLoading;
    const spinDisabled = isSpinning || !canSpin || isLoading;


   

    const checkMobileDuplicate = async (cleanMobile) => {
      try {
        const checkRes = await api.post(`${API_BASE}/api/spin/check-mobile`, {
          mobileNumber: cleanMobile,
        });
        return checkRes.data;
      } catch (err) {
        if (err?.response?.data) return err.response.data;
        if (err?.response?.status === 404) return { success: true, skipCheck: true };
        throw err;
      }
    };

// 🚫 CHECK BLOCKED NUMBER
const checkBlockedNumber = async (cleanMobile) => {
  try {
    const response = await api.get(
      `${API_BASE}/api/blocked-numbers/check`,
      {
        params: {
          mobileNumber: cleanMobile,
        },
      }
    );

    return response.data;
  } catch (err) {
    if (err?.response?.data) {
      return err.response.data;
    }

    throw err;
  }
};


    // +92 hamesha save — 03xx → 923xx
    const formatMobile = (raw) => {
      let n = digitsOnly(raw);
      if (n.startsWith('0')) n = '92' + n.slice(1);
      if (!n.startsWith('92')) n = '92' + n;
      return n;
    };
// 🚫 BLOCKED NUMBER POPUP HANDLER
const showBlockedNumberPopup = () => {
  setErrorMsg('');
  setIsSpinning(false);
  setShowBlockedPopup(true);
  stopSpeech();
};  
   const handleSpin = async () => {
    setErrorMsg('');

    if (!playerName.trim()) return showError('Please enter your full name.');

    const rawDigits = digitsOnly(mobileNumber);
    if (rawDigits.length < 10 || rawDigits.length > 12) {
      return showError(`Please enter a valid 10 or 11-digit mobile number.`);
    }

    if (!segmentsRef.current.length) return showError('Wheel is not ready yet. Please wait...');
    if (isSpinning) return;
    if (!canSpin) return showError('Wheel not ready. Please wait.');

    const savedMobile = formatMobile(rawDigits);
    // =========================================================
// 🚫 BLOCKED NUMBER CHECK
// Number BlockedNumber table mein hai to spin STOP
// =========================================================
try {
  const blockedData = await checkBlockedNumber(savedMobile);

  if (blockedData?.isBlocked === true) {
    showBlockedNumberPopup();
    return;
  }
} catch (err) {
  return showError(
    getApiErrorMessage(
      err,
      'Could not verify mobile number. Please try again.'
    )
  );
}

    // 1. Duplicate check (Specific Message Popup Added)
    // 1. Duplicate check (Specific Message Popup Added)
    try {
      const checkData = await checkMobileDuplicate(savedMobile);
      if (checkData?.success === false) {
        if (checkData.isLimitReached) {
            setPreviousWinData(checkData.previousWin || checkData.data || {
              mobile: savedMobile,
              prize: 'Discount Voucher',
              subCategory: '',
              code: 'N/A',
              status: 'Sent',
              validUntil: 'N/A'
            });
            setShowAlreadyUsedPopup(true);
        } else {
            return showError(checkData.error || 'Network error, please try again.');
        }
        return;
      }
    } catch (err) {
      return showError(getApiErrorMessage(err));
    } 

    // 2. Call backend FIRST to get the winner
    setIsSpinning(true);
    let sr;
    try {
      sr = await api.post(`${API_BASE}/api/spin/result`, {
        playerName: playerName.trim(),
        countryCode,
        mobileNumber: savedMobile,
        gender,
        storeId,
      });
// 🚫 BACKEND BLOCKED SAFETY CHECK
if (sr.data?.isBlocked === true) {
  showBlockedNumberPopup();
  return;
}
      if (!sr.data.success) {
        setIsSpinning(false);
        // FIXED: Same yahan bhi condition update karni hai
        if (sr.data.isLimitReached) {
            setPreviousWinData(sr.data.previousWin || sr.data.data || null);
            setShowAlreadyUsedPopup(true);
        } else {
            return showError(sr.data.error || 'Spin failed.');
        }
        return;
      }
   } catch (err) {
  setIsSpinning(false);

  // 🚫 BACKEND BLOCKED RESPONSE
  if (err?.response?.data?.isBlocked === true) {
    showBlockedNumberPopup();
    return;
  }

  return showError(
    getApiErrorMessage(
      err,
      'Spin failed.'
    )
  );
}

    // ... (Yahan se neechay ka animation aur result wala code same rahay ga) ...

    // 3. Setup Animation to land on the winner
    const segs = segmentsRef.current;
    const targetIndex = segs.findIndex(s => String(s.categoryId) === String(sr.data.categoryId));
    
    

    const sliceA = 360 / segs.length;
    const wCenter = targetIndex * sliceA + sliceA / 2;
    const DURATION = 20000; // 20 seconds
    const curRot = currentAngleRef.current % 360;
    const adj = (360 - (wCenter % 360)) % 360;
    const target = currentAngleRef.current + (360 - curRot) + (360 * 25) + adj;
    const startA = currentAngleRef.current;
    const startT = performance.now();

    lastTickTimeRef.current = startT;
    playTickSound(1800, 0.018, 0.03);

    let lastTickSlice = Math.floor(startA / sliceA);
    const easeOut = t => 1 - Math.pow(1 - t, 5);

    const animate = (now) => {
      const prog = Math.min((now - startT) / DURATION, 1);
      const cur = startA + (target - startA) * easeOut(prog);
      currentAngleRef.current = cur;
      drawWheel(segs, cur);

      const currentSlice = Math.floor(cur / sliceA);
      if (currentSlice > lastTickSlice) {
        const remaining = 1 - prog;
        const freq = remaining > 0.78 ? 1900 : remaining > 0.60 ? 1600 : 1300;
        const gain = remaining > 0.78 ? 0.028 : 0.05;
        playTickSound(freq, 0.14, gain);
        lastTickSlice = currentSlice;
      }

      if (prog < 1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        currentAngleRef.current = target % 360;
        drawWheel(segs, currentAngleRef.current);
        setIsSpinning(false);

        // 4. Show Congrats
        const matchedSeg = segs[targetIndex];
        const displayResult = {
          label: sr.data.prizeLabel || matchedSeg?.label || '',
          subCategory: sr.data.wonSubcategory || matchedSeg?.subCategory || '',
          categoryName: matchedSeg?.categoryName || '',
        };

        setWinningCode(sr.data.generatedCode);
        setResult(displayResult);
        setShowCongrats(true);
        speakText(`Congratulations! You have won ${displayResult.label} discount on ${displayResult.subCategory || 'shoes'}.`);
        triggerConfetti();
      }
    };

    rafRef.current = requestAnimationFrame(animate);
  };

   const redT   = Math.max(18, wheelSize * 0.082);
const silT   = Math.max(4,  wheelSize * 0.018);
const silD   = wheelSize + silT * 2;
const outD   = silD + redT * 2;

/* NEW: outer dark-brown ring */
const outerBrownT = Math.max(10, wheelSize * 0.045);
const outerBrownD = outD + outerBrownT * 2;

/* Outer brown ring ke center par bulbs */
const outerBrownBulbR = outD / 2 + outerBrownT / 2;

const contD  = outerBrownD + (wheelSize > 200 ? 24 : 14);

const silR   = silD / 2;
const dH     = Math.max(14, silT * 7.0);
const dW     = Math.max(9,  silT * 40 / 6.0);
// === PURANAY dotAng AUR dotSz KO IN SE REPLACE KAREIN ===
// === 18 BULBS AUR PERFECT LETAY HUE OVALS KE SIZES ===
  const dotAng = Array.from({ length: 18 }, (_, i) => i * 20); // 18 lights (har 20 degree par)
  const diaAng = [0, 45, 90, 135, 180, 225, 270, 315];
  
  // W ko lamba aur H ko patla rakha hai taake capsule/leta hua oval bane
  const bulbW  = Math.max(14, wheelSize * 0.055); // Lambai (Length)
  const bulbH  = Math.max(6,  wheelSize * 0.015); // Motayi (Thickness)
  const logoSz = Math.max(44, wheelSize * 0.24);  

  /* =========================================================
     CODE-ONLY GOLD PODIUM (NO IMAGE / NO LIBRARY)
     ========================================================= */
  const podiumH = Math.max(112, Math.min(150, wheelSize * 0.99));
const podiumW = Math.min(420, Math.max(280, wheelSize * 1));
const podiumVisualH = podiumW * 0.32;

const wheelPodiumGap = 0;
const stageH = contD + wheelPodiumGap + podiumVisualH;

      return (
<div
  ref={stageRef}
  style={{
    height: 'calc(100dvh - -15px)',
    width: '100%',
    maxWidth: `${DESIGN_WIDTH}px`,
    position: 'fixed',
    top: '42px',
    left: '50%',
    transform: 'translateX(-50%)',
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    zIndex: 1,
    overflow: 'hidden',
    padding: 0,
    boxSizing: 'border-box',
    isolation: 'isolate',
  }}
>
  
    {/* 🔹 MIRRORED BACKGROUND LAYER 🔹 */}
<div
  style={{
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    zIndex: 0,
    pointerEvents: 'none',
    overflow: 'hidden',
  }}
>
  <img
  src={bgImage}
  alt=""
  style={{
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    display: 'block',
    objectFit: 'fill',
    objectPosition: 'center top',
  }}
/>
</div>




    
        <style>
          {` 
            @keyframes crazyShake {
              0% { transform: scale(1) skewY(-8deg) translate(0,0); }
              25% { transform: scale(1.1) skewY(-8deg) translate(10px, -10px); }
              50% { transform: scale(1.2) skewY(-8deg) translate(-10px, 10px); }
              75% { transform: scale(1.1) skewY(-8deg) translate(10px, 10px); }
              100% { transform: scale(1) skewY(-8deg) translate(0,0); }
            }
            @keyframes popIn{from{opacity:0;transform:scale(0.65) translateY(40px);}to{opacity:1;transform:scale(1) translateY(0);} }
            @keyframes slideDown{from{opacity:0;transform:translateX(-50%) translateY(-30px);}to{opacity:1;transform:translateX(-50%) translateY(0);} }

            @keyframes blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0; }
            }

            @keyframes podiumGlow {
              from { opacity: 0.72; }
              to { opacity: 1; }
            }

           .responsive-wrapper-card {
  position: absolute;
  inset: 0;
  z-index: 5;
  width: 100%;
  max-width: 440px;
  height: 100%;
  padding: 0;
  text-align: center;
  display: block;
  box-sizing: border-box;
}

         .responsive-flex-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

            .responsive-form-box {
              width: 100%;
              max-width: 360px;
              display: flex;
              flex-direction: column;
              gap: 3px;
              margin-top: 2px;
            }

            @media (max-height: 760px) {
              .responsive-wrapper-card {
                padding: 4  px 12px !important;
              }
              
              .responsive-form-box {
                gap: 3px !important;
              }
              h1 {
                font-size: 26px !important;
              }
            }
          `}
        </style>

        {errorMsg && (
          <div style={{
            width:'90%', maxWidth:'500px',
            margin:'0 auto 12px auto',
            backgroundColor:'#C62828',
            color:'white',
            padding:'12px 18px',
            borderRadius:'12px',
            fontWeight:'bold',
            fontSize:'14px',
            fontFamily:'Arial, sans-serif',
            boxShadow:'0 6px 20px rgba(0,0,0,0.45)',
            textAlign:'center',
            border:'2px solid rgba(255,215,0,0.6)',
            lineHeight:1.4,
            position:'relative',
            zIndex:50
          }}>
            ⚠️ {errorMsg}
          </div>
        )}
  <Participated
  showAlreadyUsedPopup={showAlreadyUsedPopup}
  onClose={() => setShowAlreadyUsedPopup(false)}
  previousWinData={previousWinData}
  mobileNumber={mobileNumber}
  formatMobile={formatMobile}
/>



      <div className="responsive-wrapper-card">
          <div
            style={{
              marginTop: '0px',
              marginBottom: '-30px', /* 100px ko 10px kar dein */
              width: '100%',
              textAlign: 'center',
            }}
          >
          </div>

           <div className="responsive-flex-container">
                        <div
  style={{
    position: 'absolute',
    left: '50%',
    top: `calc(55% - ${stageH + 3 - (podiumVisualH / 2)}px)`,
    transform: 'translateX(-50%)',
    width: `${Math.min(430, Math.max(contD, podiumW))}px`,
    height: `${stageH}px`,
    zIndex: 10,
    overflow: 'visible',
  }}
>
              {/* =========================================================
                  CODE-ONLY GOLD PODIUM / PEDESTAL
                  Wheel sits directly on the top platform.
                 ========================================================= */}
      {/* ========================================================= 
    CODE-ONLY PREMIUM GOLDEN PODIUM (SLIM & RESPONSIVE) 
   ========================================================= */} 
{/* ========================================================= 
    CODE-ONLY PREMIUM GOLDEN PODIUM (BALANCED THICKNESS & GLOWING LIGHTS) 
   ========================================================= */} 
<div 
  style={{ 
    position: 'absolute', 
    left: '50%', 
    bottom: '-20px',  
    transform: 'translateX(-50%)', 
    width: `${225}px`,               // 👈 Responsive width (${podiumW})
    height: `${podiumVisualH}px`,
    zIndex: 2, 
    pointerEvents: 'none', 
  }} 
> 
  {/* 1. LOWER TIER - BODY */} 
  <div style={{ 
    position: 'absolute', 
    bottom: 0, left: 0, 
    width: '100%', 
    height: `${podiumW * 0.15}px`,      // 👈 Lower tier ko thoda motta kiya (0.10 -> 0.15)
    background: 'linear-gradient(90deg, #2b1101 0%, #7a450a 15%, #ffd76b 25%, #ffffff 28%, #ffd76b 32%, #b37414 45%, #422002 60%, #b37414 72%, #ffffff 80%, #ffd76b 83%, #7a450a 90%, #2b1101 100%)', 
    borderRadius: `75% 75% 75% 75% / ${podiumW * 0.07}px ${podiumW * 0.07}px ${podiumW * 0.07}px ${podiumW * 0.07}px`,
    borderBottom: '2px solid #fff3b0', 
  }} /> 

  {/* 2. LOWER TIER - TOP SURFACE & RIM LIGHTS */} 
  <div style={{ 
    position: 'absolute', 
    bottom: `${podiumW * 0.06}px`, 
    left: 0, 
    width: '100%', 
    height: `${podiumW * 0.12}px`,      // 👈 Surface ki thickness adjust ki
    background: 'radial-gradient(ellipse at 50% 30%, #fffae0 0%, #ffcc4d 25%, #995c0f 65%, #381a01 100%)', 
    borderRadius: '50%', 
    border: '1.5px solid #ffe885', 
  }}> 
    {[ 
      { top: '22%', left: '20%' }, { top: '26%', right: '20%' }, 
      { bottom: '50%', left: '10%' }, { bottom: '41%', left: '30%' }, { bottom: '35%', left: '50%' }, 
      { bottom: '40%', right: '30%' }, { bottom: '50%', right: '10%' }, 
    ].map((pos, i) => ( 
      <div key={`low-flare-${i}`} style={{ 
        position: 'absolute',  
        width: '6px',  
        height: '3px',  
        backgroundColor: '#ffffff', 
        borderRadius: '50%',  
        transform: 'translate(-50%, -50%)', 
        boxShadow: '0 0 8px 3px #ffea8c, 0 0 14px 6px #d48806', // ✨ SHINING GLOW LIGHTS WAPAS ADD KAR DI
        zIndex: 9,  
        ...pos 
      }} /> 
    ))} 
  </div> 

  {/* 3. UPPER TIER - BODY */} 
  <div style={{ 
    position: 'absolute', 
    bottom: `${podiumW * 0.10}px`,  
    left: '13.5%', 
    width: '75%', 
    height: `${podiumW * 0.25}px`,      // 👈 Upper tier ko motta kiya (0.12 -> 0.25)
    background: 'linear-gradient(90deg, #8b461b 0%, #7a450a 15%, #ffd76b 25%, #ffffff 28%, #ffd76b 32%, #b37414 45%, #422002 60%, #b37414 72%, #ffffff 80%, #ffd76b 83%, #7a450a 90%, #2b1101 100%)', 
    borderRadius: `0 0 50% 50% / 0 0 ${podiumW * 0.75 * 0.07}px ${podiumW * 0.75 * 0.07}px`, 
    borderBottom: '2px solid #fff3b0', 
  }} /> 

  {/* 4. UPPER TIER - TOP SURFACE */} 
  <div style={{ 
    position: 'absolute', 
    bottom: `${podiumW * 0.16}px`,  
    left: '13.5%', 
    width: '75%', 
    height: `${podiumW * 0.10}px`,      // 👈 Top surface thickness adjust ki
    background: 'radial-gradient(ellipse at 50% 30%, #ffcc4d 0%, #ffcc4d 25%, #995c0f 65%, #381a01 100%)', 
    borderRadius: '50%', 
    border: '1.5px solid #ffe885', 
  }}> 
    {[ 
      { top: '22%', left: '16%' },   
      { top: '22%', right: '16%' },  
    ].map((pos, i) => ( 
      <div key={`up-flare-${i}`} style={{ 
        position: 'absolute',  
        width: '6px',  
        height: '3px',  
        backgroundColor: '#ede9cb', 
        borderRadius: '50%',  
        transform: 'translate(-50%, -50%)', 
        boxShadow: '0 0 10px 4px #ffcc00, 0 0 20px 8px #ff6600', // ✨ SHINING GLOW LIGHTS WAPAS ADD KAR DI
        zIndex: 3,  
        ...pos 
      }} /> 
    ))} 
  </div> 
</div>
 
{/* WHEEL STACK */} 
<div style={{ 
  position: 'absolute', top: 60, left: '50%', transform: 'translateX(-50%)', 
  width: `${contD}px`, height: `${contD}px`, 
  display: 'flex', justifyContent: 'center', alignItems: 'center', 
  zIndex: 10, flexShrink: 0 
}}>
                 {/* =========================================================
                    NEW DESIGN: OUTER BROWN RING + EXISTING GOLD RING
                  ========================================================= */}
                <div
                  style={{
                    position: 'absolute',
                    width: `${outerBrownD}px`,
                    height: `${outerBrownD}px`,
                    borderRadius: '50%',
                    background: `radial-gradient(circle at 35% 30%, #6B3E0E 0%, #6B3E0E 28%, #6B3E0E 58%, #6B3E0E 100%)`,
                    border: '2px solid #a06433',
  filter: 'drop-shadow(0px 12px 14px rgba(61, 35, 35, 0.85))',
      boxShadow: `inset 0 4px 6px #8A4812, inset 0 -7px 10px #8A4812`,
                    zIndex: 10,
                    clipPath: 'polygon(0% 0%, 500% 0%, 100% 93%, 85% 93%, 85% 100%, 15% 100%, 15% 93%, 0% 93%)'
                  }}
                >
{/* SOFT SHIMMER ANIMATION CSS (Bulb gayab nahi hoga, bas halka sa dim-bright hoga) */}
<style>{`
  @keyframes softCasinoPulse {
    0%, 100% {
      /* FULL GLOW - Tezz chamak */
      opacity: 1;
      background: #ffffff; 
      box-shadow: 0 0 8px 3px #FFFF99, 0 0 18px 6px #FFD700, 0 0 26px 8px #FFA500;
    }
    50% {
      /* HALKI GLOW - Bulb saaf nazar aayega, bas roshni thodi kam hogi */
      opacity: 0.85;
      background: #fefce8; 
      box-shadow: 0 0 4px 1px #FFD700, 0 0 8px 3px rgba(255, 215, 0, 0.5); 
    }
  }
`}</style>

{/* BULBS ON BROWN RING */}
{dotAng.map((deg, idx) => {
  const r = (deg * Math.PI) / 180;
  return (
    <div
      key={`outer-bulb-${idx}`}
      style={{
        position: 'absolute',
        left: `${outerBrownD / 2 + Math.cos(r) * outerBrownBulbR - bulbW / 2}px`,
        top: `${outerBrownD / 2 + Math.sin(r) * outerBrownBulbR - bulbH / 2}px`,
        width: `${bulbW}px`,
        height: `${bulbH}px`,
        borderRadius: '50%',
        background: '#efefcd',
        transform: `rotate(${deg + 90}deg)`,
        zIndex: 25,
        pointerEvents: 'none',
        
        // SOFT PULSING ANIMATION (Smooth aur halki blinking)
        animation: 'softCasinoPulse 1.2s infinite ease-in-out alternate',
        
        // Soft Alternating Timing
        animationDelay: `${(idx % 2) * 0.6}s` 
      }}
    />
  );
})}

                  {/* EXISTING METALLIC GOLD RING */}
                  <div
                    style={{
                      position: 'absolute',
                      left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
                      width: `${outD}px`, height: `${outD}px`,
                      borderRadius: '50%',
                      background: 'conic-gradient(from 0deg, #CE954C 0%, #D4962A 20%, #CE954C 40%, #CE954C 60%, #D4962A 80%, #CE954C 100%)',
                      boxShadow: `inset 0 3px 6px rgba(255,255,255,0.8), inset 0 -4px 8px rgba(0,0,0,0.7)`,
                      border: '2px solid #D4962A',
                      zIndex: 11,
                      pointerEvents: 'none'
                    }}
                  >
                    {/* EXISTING INNER DARK-BROWN RING WITH DIAMONDS */}
                    <div
                      style={{
                        position: 'absolute',
                        left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
                        width: `${silD}px`, height: `${silD}px`,
                        borderRadius: '50%',
                        background: 'radial-gradient(circle, #944C13 0%, #3B1B04 100%)',
                        boxShadow: 'inset 0 0 8px rgba(0,0,0,0.9), 0 0 0 2px #CF943F',
                        zIndex: 12,
                        pointerEvents: 'none'
                      }}
                    >
                      {diaAng.map((deg, idx) => {
                        const r = (deg * Math.PI) / 180;
                        return (
                          <div
                            key={`diamond-${idx}`}
                            style={{
                              position: 'absolute',
                              left: `${silD / 2 + Math.cos(r) * silR - dW / 2}px`,
                              top: `${silD / 2 + Math.sin(r) * silR - dH / 2}px`,
                              width: `${dW}px`, height: `${dH}px`,
                              zIndex: 13,
                              pointerEvents: 'none'
                            }}
                          >
                            <svg width={dW} height={dH} viewBox="0 0 15 38" style={{ transform: `rotate(${deg}deg)` }}>
                              <path d="M12 1 L23 19 L12 37 L1 19 Z" fill="#4B290E" stroke="#4B290E" strokeWidth="1.2" />
                            </svg>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>

              <canvas
              
    ref={canvasRef}
    style={{
      position: 'absolute',
      width: `${wheelSize}px`,
      height: `${wheelSize}px`,
      borderRadius: '50%',
      zIndex: 20,
      display: 'block'
    }}
  />

             <div
  onClick={() => { if (!spinDisabled) handleSpin(); }}
  style={{
    position: 'absolute',
    width: `${logoSz}px`,
    height: `${logoSz}px`,
    borderRadius: '50%',
    background: '#D49D43',
    boxShadow: '0 3px 8px rgba(0,0,0,0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 30,
    cursor: spinDisabled ? 'default' : 'pointer'
  }}
>
  <span
    style={{
      fontWeight: 900,
      fontSize: `${Math.max(10, wheelSize * 0.045)}px`,
      fontFamily: '"Century Gothic", sans-serif',
      color: '#ffffff',
      letterSpacing: '2px'
    }}
  > 
    LOGO
  </span>
</div>

            
<div style={{
  position:'absolute', top:`${(contD - outD) / 2 - 28}px`, left:'50%',
  transform:'translateX(-50%)', zIndex:100, overflow:'visible',
  filter:`drop-shadow(0px 3px 4px rgba(0,0,0,0.55)) drop-shadow(0px 0px 9px rgba(255,190,50,0.32))`,
  pointerEvents:'none',
}}>
  <svg width="45" height="60" viewBox="0 0 60 80" fill="none"
    xmlns="http://www.w3.org/2000/svg" style={{overflow:'visible',display:'block'}}>
    <defs>
      {/* Main metallic gold */}
      <linearGradient id="pointerGold" x1="5" y1="5" x2="55" y2="75" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFF8D7"/><stop offset="14%" stopColor="#FFE99A"/><stop offset="32%" stopColor="#F6D16A"/>
        <stop offset="52%" stopColor="#DFA83F"/><stop offset="72%" stopColor="#B9791D"/><stop offset="88%" stopColor="#F0C75A"/><stop offset="100%" stopColor="#FFF0AD"/>
      </linearGradient>
      {/* Inner warm gold */}
      <linearGradient id="pointerInnerGold" x1="13" y1="12" x2="48" y2="68" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFF3B8"/><stop offset="35%" stopColor="#E4B44D"/><stop offset="65%" stopColor="#C58A28"/><stop offset="100%" stopColor="#F4D06A"/>
      </linearGradient>
      {/* Bright center highlight */}
      <radialGradient id="pointerGlow" cx="50%" cy="35%" r="65%"><stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.95"/><stop offset="25%" stopColor="#FFF4B8" stopOpacity="0.9"/><stop offset="55%" stopColor="#FFD65A" stopOpacity="0.35"/><stop offset="100%" stopColor="#FFD65A" stopOpacity="0"/></radialGradient>
      {/* Hole gradient */}
      <radialGradient id="pointerHole" cx="35%" cy="30%" r="70%"><stop offset="0%" stopColor="#4B2B0C"/><stop offset="55%" stopColor="#241204"/><stop offset="100%" stopColor="#0C0703"/></radialGradient>
      {/* Outer shadow */}
      <filter id="pointerShadow" x="-50%" y="-50%" width="200%" height="220%"><feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="#4E2607" floodOpacity="0.75"/></filter>
      {/* Golden glow */}
      <filter id="pointerLight" x="-100%" y="-100%" width="300%" height="300%"><feGaussianBlur stdDeviation="3" result="blur"/></filter>
      {/* Tip glow */}
      <filter id="tipGlow" x="-200%" y="-200%" width="400%" height="400%"><feGaussianBlur stdDeviation="2" result="glow"/></filter>
      {/* Soft highlight */}
      <linearGradient id="pointerShine" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.85"/><stop offset="35%" stopColor="#FFF4C4" stopOpacity="0.45"/><stop offset="100%" stopColor="#FFFFFF" stopOpacity="0"/></linearGradient>
    </defs>
    {/* ================================================= SOFT GOLDEN LIGHT BEHIND POINTER ================================================= */}
    <path d="M30 5 C14 5 4 17 4 32 C4 45 20 65 26 74 C28 77 32 77 34 74 C40 65 56 45 56 32 C56 17 46 5 30 5 Z" fill="#FFD45A" opacity="0.22" filter="url(#pointerLight)"/>
    {/* ================================================= MAIN POINTER BODY ================================================= */}
    <path d="M30 8 C16 8 6 18 6 32 C6 44 22 64 27 71 C28.5 73 31.5 73 33 71 C38 64 54 44 54 32 C54 18 44 8 30 8 Z" fill="url(#pointerGold)" stroke="#6E3B0D" strokeWidth="3" strokeLinejoin="round" filter="url(#pointerShadow)"/>
    {/* ================================================= THIN INNER LIGHT-BROWN / GOLD BORDER ================================================= */}
    <path d="M30 11 C18 11 9.5 20.2 9.5 32 C9.5 42.5 24 61.5 28.8 68.3 C29.4 69.2 30.6 69.2 31.2 68.3 C36 61.5 50.5 42.5 50.5 32 C50.5 20.2 42 11 30 11 Z" fill="none" stroke="#F8DC8A" strokeWidth="1.2" opacity="0.95"/>
    {/* ================================================= INNER GOLD SHADING ================================================= */}
    <path d="M30 13 C20 13 11.5 21.5 11.5 32 C11.5 41.5 24.5 58.5 29 65 C29.5 65.8 30.5 65.8 31 65 C35.5 58.5 48.5 41.5 48.5 32 C48.5 21.5 40 13 30 13 Z" fill="url(#pointerInnerGold)" opacity="0.32"/>
    {/* ================================================= METALLIC SHINE ON LEFT SIDE ================================================= */}
    <path d="M13 28 C14 19 21 13 28 12 C23 19 20 29 21 39 C21.5 46 24 54 27 60 C20 51 14 40 13 28 Z" fill="url(#pointerShine)" opacity="0.8"/>
    {/* ================================================= SMALL BRIGHT SHINE ================================================= */}
    <path d="M17 23 C20 17 25 14 30 14" stroke="#FFFFFF" strokeWidth="1.4" strokeLinecap="round" opacity="0.55"/>
    {/* ================================================= CENTER / TOP HOLE ================================================= */}
    <circle cx="30" cy="30" r="11" fill="#FFD75C" opacity="0.24" filter="url(#pointerLight)"/>
    <circle cx="30" cy="30" r="7.3" fill="url(#pointerHole)" stroke="#5D330D" strokeWidth="1.3"/>
    <ellipse cx="27.5" cy="27.2" rx="2.1" ry="1.3" fill="#FFF1B4" opacity="0.32"/>
    {/* ================================================= INTENSE SPARKLE / LENS FLARE AT THE TIP ================================================= */}
    {/* Outer soft glow */}
    <circle cx="30" cy="67" r="8" fill="#FFE58F" opacity="0.45" filter="url(#tipGlow)"/>
    {/* Vertical light streak */}
    <ellipse cx="30" cy="67" rx="1.2" ry="6.5" fill="#FFFFFF" opacity="0.95" filter="url(#tipGlow)"/>
    {/* Horizontal light streak */}
    <ellipse cx="30" cy="67" rx="6.5" ry="1.2" fill="#FFFFFF" opacity="0.95" filter="url(#tipGlow)"/>
    {/* Bright center diamond core */}
    <circle cx="30" cy="67" r="2" fill="#FFFFFF" opacity="1"/>
  </svg>
</div>
</div>
</div>

        <div
  className="responsive-form-box"
  style={{
    position: 'absolute',
    left: '50%',

    // PODIUM ke bilkul 3px neeche
    top: `calc(55% + ${(podiumVisualH / 2) + 50}px)`,

    transform: 'translateX(-50%)',

    width: '55%',
    maxWidth: '360px',

    display: 'flex',
    flexDirection: 'column',

    gap: '2px',

    zIndex: 50,
    boxSizing: 'border-box',

    // Neeche complete form visible rakhne ke liye
  }}
>
              <div
                style={{
                  display: 'flex',
                  gap: '4px',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <button
                  type="button"
                  onClick={() => { if (!isSpinning) setGender('male'); }}
                  disabled={isSpinning}
                  style={{
                    flex: 1,
                    padding: '1px 0',
                    borderRadius: '36px',
                    border: 'none',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    cursor: isSpinning ? 'not-allowed' : 'pointer',
                    background: gender === 'male' ? 'linear-gradient(135deg, #B58632, #F6DD7C)' : '#f0f0f0',
                    color: gender === 'male' ? '#503314' : '#503314',
                    boxShadow: gender === 'male' ? '0 4px 12px rgba(30,136,229,0.4)' : 'none',
                    transition: 'all 0.2s ease',
                    boxSizing: 'border-box'
                  }}
                >
                  ♂ Male
                </button>

                <button
                  type="button"
                  onClick={() => { if (!isSpinning) setGender('female'); }}
                  disabled={isSpinning}
                  style={{
                    flex: 1,
                    padding: '4px 0',
                    borderRadius: '36px',
                    border: 'none',
                    fontWeight: 'bold',
                    fontSize: '13px',
                    cursor: isSpinning ? 'not-allowed' : 'pointer',
                    background: gender === 'female' ? 'linear-gradient(135deg, #B58632, #F6DD7C)' : '#f0f0f0',
                    color: gender === 'female' ? '#503314' : '#503314',
                    boxShadow: gender === 'female' ? '0 4px 12px rgba(233,30,99,0.4)' : 'none',
                    transition: 'all 0.2s ease',
                    boxSizing: 'border-box'
                  }}
                >
                  ♀ Female
                </button>
              </div>

              <input
                type="text"
                placeholder="Your full name"
                style={{
                  width: '100%',
                  height: '30px',
                  padding: '0 12px',
                  borderRadius: '10px',
                  border: 'none',
                  boxSizing: 'border-box',
                  fontSize: '13px',
                  outline: 'none',
                  boxShadow: '0 3px 10px rgba(0,0,0,0.14)',
                  margin: 0
                }}
                value={playerName}
                onChange={e => setPlayerName(e.target.value)}
                disabled={spinDisabled}
              />

              <div
                style={{
                  display: 'flex',
                  gap: '1px', 
                  width: '100%',            
                  boxSizing: 'border-box'
                }}
              >
                <select
                  value={countryCode}
                  onChange={e => setCountryCode(e.target.value)}
                  style={{
                    width: '35px', 
                    height: '30px', 
                    padding: '0 0 0 6px', 
                    borderRadius: '10px',
                    border: 'none',
                    fontSize: '12px', 
                    boxShadow: '0 3px 10px rgba(0,0,0,0.14)',
                    boxSizing: 'border-box',
                    margin: 0,
                    backgroundColor: '#fff',
                    flexShrink: 0,
                    cursor: 'pointer',
                    appearance: 'none', 
                    WebkitAppearance: 'none'
                  }}
                  disabled={spinDisabled}
                >
                  <option value="PK">+92</option>
                  <option value="AE">+971</option>
                </select>
                <input
                  type="tel"
                  placeholder="3023456789"
                  maxLength={10}
                  style={{
                    flex: 1,
                    minWidth: '0',
                    height: '30px',
                    padding: '0 14px',
                    borderRadius: '10px',
                    border: 'none',
                    fontSize: '14px',
                    outline: 'none',
                    boxShadow: '0 1px 10px rgba(0,0,0,0.14)',
                    boxSizing: 'border-box',
                    margin: 0,
                    fontFamily: 'inherit'
                  }}
                  value={mobileNumber}
                  onChange={e => setMobileNumber(e.target.value.replace(/\D/g,'').slice(0,12))}
                  disabled={spinDisabled}
                />
              </div>

              <button
                onClick={handleSpin}
                disabled={spinDisabled}
                style={{  
                  width: '100%',
                  minHeight: 'clamp(30px, 5vh, 36px)',
                  padding: '0 clamp(10px, 3vw, 16px)',
                  borderRadius: '10px',
                  border: 'none',
                  background: spinDisabled
                    ? '#6e6e6e'
                    : 'linear-gradient(180deg,#F6DD7C 0%,#BC8F39 45%,#F6DD7C 100%)',
                  color: '#503314',
                  fontWeight: 900,
                  cursor: spinDisabled ? 'not-allowed' : 'pointer',
                  fontSize: 'clamp(13px, 3.5vw, 15px)',
                  lineHeight: 1,
                  letterSpacing: 'clamp(0.6px, 0.2vw, 1px)',
                  transition: 'all 0.3s ease',
                  fontFamily: "'Arial Black',Arial,sans-serif",
                  boxShadow: spinDisabled ? 'none' : '0 4px 12px rgba(229,57,53,0.42)',
                  boxSizing: 'border-box',
                  margin: 0,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {isLoading
                  ? 'LOADING...'
                  : isSpinning
                    ? '• SPINNING... •'
                    : '• SPIN NOW •'}
              </button>
            </div>
          </div>
        </div>

          <Congratulations
        showCongrats={showCongrats}
        result={result}
        winningCode={winningCode}
        onClose={resetWheelVisuals}
      />
    </div>
  );
}





//   import React, { useState, useRef, useEffect, useCallback } from 'react';
//   import api from '../api/api';
//   import bgImage from '../assets/bg.png'; // <--- Yeh line yahan add karni hai
//  import Congratulations from '../components/congratulation';
// import Participated from '../components/participated';
// import confetti from 'canvas-confetti';
//  const DESIGN_WIDTH = 440;
// const DESIGN_HEIGHT = 726;
// const DESIGN_WHEEL_SIZE = 210;
 
//   const wheelColors = [
//   '#BF0301', '#030101', 
//   '#BF0301', '#030101', 
//   '#BF0301', '#030101', 
//   '#BF0301', '#030101', 
//   '#BF0301', '#030101',   
// ];

//   const DEFAULT_SEGMENTS_MALE = [
//     { label: '10% OFF',   winWeight: 25, categoryId: 'test1', categoryName: 'Discount', subCategory: 'All Items' },
//     { label: 'FREE ITEM', winWeight: 15, categoryId: 'test2', categoryName: 'Gift',     subCategory: 'Selected Items' },
//     { label: '5% OFF',    winWeight: 30, categoryId: 'test3', categoryName: 'Discount', subCategory: 'Mens Shoes' },
//     { label: 'TRY AGAIN', winWeight: 30, categoryId: 'test4', categoryName: 'No Win',   subCategory: '' },
//   ];

//   const DEFAULT_SEGMENTS_FEMALE = [
//     { label: '15% OFF',   winWeight: 25, categoryId: 'test5', categoryName: 'Discount', subCategory: 'All Items' },
//     { label: 'FREE ITEM', winWeight: 15, categoryId: 'test6', categoryName: 'Gift',     subCategory: 'Selected Items' },
//     { label: '10% OFF',   winWeight: 30, categoryId: 'test7', categoryName: 'Discount', subCategory: 'Ladies Shoes' },
//     { label: 'TRY AGAIN', winWeight: 30, categoryId: 'test8', categoryName: 'No Win',   subCategory: '' },
//   ];

//   export default function SpinWheel() {
//     const [segments, setSegments]               = useState([]);
//     const [playerName, setPlayerName]           = useState('');
//     const [countryCode, setCountryCode]         = useState('+92');
//     const [mobileNumber, setMobileNumber]       = useState('');
//     const [gender, setGender]                   = useState('male');
//     const [isSpinning, setIsSpinning]           = useState(false);
//     const [result, setResult]                   = useState(null);
//     const [showCongrats, setShowCongrats]       = useState(false);
//     const [winningCode, setWinningCode]         = useState('');
// const [wheelSize] = useState(DESIGN_WHEEL_SIZE);
// const [stageScale, setStageScale] = useState(1);
//     const [errorMsg, setErrorMsg]               = useState('');
//     const [isLoading, setIsLoading]             = useState(true);
    
//     // NEW STATE FOR ALREADY USED POPUP
//     const [showAlreadyUsedPopup, setShowAlreadyUsedPopup] = useState(false);
//     // NEW STATE FOR PREVIOUS WIN DATA
//     const [previousWinData, setPreviousWinData] = useState(null);
//     const [showBlockedPopup, setShowBlockedPopup] = useState(false);
//     const params = new URLSearchParams(window.location.search);
//     const storeId = params.get('storeId');

//     const currentAngleRef    = useRef(0);
// const rafRef             = useRef(null);
// const canvasRef          = useRef(null);
// const stageRef           = useRef(null);
// const autoResetTimerRef  = useRef(null);
// const errorTimeoutRef    = useRef(null);
// const segmentsRef        = useRef([]);

//     // Voice / sound helpers
//     const synthRef           = useRef(typeof window !== 'undefined' ? window.speechSynthesis : null);
//     const femaleVoiceRef     = useRef(null);
//     const voiceInitTimerRef  = useRef(null);
//     const audioCtxRef        = useRef(null);
//     const lastTickTimeRef    = useRef(0);

//     const API_BASE = api ? api.defaults.baseURL || '' : '';

//     // ─── helpers ────────────────────────────────────────────────────────────────
//     const showError = (message) => {
//       if (errorTimeoutRef.current) clearTimeout(errorTimeoutRef.current);
//       setErrorMsg(message);
//       errorTimeoutRef.current = setTimeout(() => setErrorMsg(''), 7000);
//     };

//     const digitsOnly = (s) => (s || '').replace(/\D/g, '');

//     const getApiErrorMessage = (err, fallback = 'Network error. Please check your connection and try again.') => {
//       return (
//         err?.response?.data?.message ||
//         err?.response?.data?.error   ||
//         err?.message                 ||
//         fallback
//       );
//     };

// const triggerConfetti = () => {
//   const end = Date.now() + 2500; // Sirf 2.5 sec tak particles spawn honge

//   const colors = [
//     '#FFD700',
//     '#FDB931',
//     '#D4AF37',
//     '#FFF8DC',
//     '#E6C200',
//     '#DAA520',
//   ];

//   (function frame() {
//     confetti({
//       particleCount: 4,

//       // Top se neeche
//       angle: 270,

//       spread: 70,

//       // Hamesha screen ke upper edge se
//       origin: {
//         x: Math.random(),
//         y: -0.05,
//       },

//       colors,

//       // Thori fast falling
//       gravity: 0.18,

//       // Natural halka sway
//       drift: Math.random() * 0.3 - 0.15,

//       // Mixed particle sizes
//       scalar: Math.random() * 0.35 + 0.8,

//       // Particle enough time tak fall kare,
//       // phir automatically disappear ho jaye
//       ticks: 180,
//     });

//     if (Date.now() < end) {
//       requestAnimationFrame(frame);
//     }
//   })();
// };


//     // ─── voice helpers ─────────────────────────────────────────────────────────
//     const pickFemaleVoice = useCallback(() => {
//       try {
//         const synth = synthRef.current;
//         if (!synth) return null;
//         const voices = synth.getVoices?.() || [];
//         if (!voices.length) return null;

//         const preferred = voices.find(v => /female|zira|susan|samantha|victoria|karen|moira|tessa|allison|ava|veena|laila/i.test(v.name || ''));
//         if (preferred) return preferred;

//         const enVoice = voices.find(v => /^en(-|_)?/i.test(v.lang || '') && !/male/i.test(v.name || ''));
//         if (enVoice) return enVoice;

//         return voices[0] || null;
//       } catch {
//         return null;
//       }
//     }, []);

//     const initVoices = useCallback(() => {
//       if (typeof window === 'undefined') return;
//       const synth = synthRef.current;
//       if (!synth) return;
//       femaleVoiceRef.current = pickFemaleVoice();
//     }, [pickFemaleVoice]);

//     const speakText = useCallback((text, { rate = 1, pitch = 1.15, volume = 1 } = {}) => {
//       try {
//         if (typeof window === 'undefined') return;
//         const synth = synthRef.current;
//         if (!synth || !('SpeechSynthesisUtterance' in window)) return;

//         synth.cancel();
//         const utterance = new SpeechSynthesisUtterance(text);
//         utterance.rate = rate;
//         utterance.pitch = pitch;
//         utterance.volume = volume;
//         utterance.lang = 'en-US';
//         if (!femaleVoiceRef.current) femaleVoiceRef.current = pickFemaleVoice();
//         if (femaleVoiceRef.current) utterance.voice = femaleVoiceRef.current;
//         synth.speak(utterance);
//       } catch {
//         // silent fail
//       }
//     }, [pickFemaleVoice]);

//     const stopSpeech = useCallback(() => {
//       try {
//         if (typeof window === 'undefined') return;
//         const synth = synthRef.current;
//         if (synth) synth.cancel();
//       } catch {
//         // silent fail
//       }
//     }, []);

//     const playTickSound = useCallback((frequency = 12000, duration = 0.03, gainValue = 8) => {
//       try {
//         if (typeof window === 'undefined') return;
//         const AudioContextClass = window.AudioContext || window.webkitAudioContext;
//         if (!AudioContextClass) return;

//         if (!audioCtxRef.current) {
//           audioCtxRef.current = new AudioContextClass();
//         }

//         const ctx = audioCtxRef.current;
//         if (ctx.state === 'suspended') {
//           ctx.resume?.();
//         }

//         const oscillator = ctx.createOscillator();
//         const gainNode = ctx.createGain();

//         oscillator.type = 'square';
//         oscillator.frequency.setValueAtTime(frequency, ctx.currentTime);

//         gainNode.gain.setValueAtTime(gainValue, ctx.currentTime);
//         gainNode.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration);

//         oscillator.connect(gainNode);
//         gainNode.connect(ctx.destination);

//         oscillator.start();
//         oscillator.stop(ctx.currentTime + duration);
//       } catch {
//         // silent fail
//       }
//     }, []);

//     useEffect(() => {
//       initVoices();
//       if (typeof window !== 'undefined') {
//         const synth = synthRef.current;
//         if (synth && 'onvoiceschanged' in synth) {
//           synth.onvoiceschanged = initVoices;
//         } else {
//           voiceInitTimerRef.current = setTimeout(initVoices, 500);
//         }
//       }

//       return () => {
//         if (voiceInitTimerRef.current) clearTimeout(voiceInitTimerRef.current);
//         stopSpeech();
//       };
//     }, [initVoices, stopSpeech]);

//    // ─────────────────────────────────────────────
// // RESPONSIVE ARTBOARD SCALE
// // ─────────────────────────────────────────────
// useEffect(() => {
//   const updateStageScale = () => {
//     const stage = stageRef.current;
//     if (!stage) return;

//     const viewportWidth = window.visualViewport?.width || window.innerWidth;
//     const viewportHeight = window.visualViewport?.height || window.innerHeight;
//     const stageTop = Math.max(0, stage.getBoundingClientRect().top);
//     const availableWidth = Math.min(stage.clientWidth, viewportWidth);
//     const availableHeight = Math.max(0, viewportHeight - stageTop - 12);

//     const widthScale = availableWidth / DESIGN_WIDTH;
//     const heightScale = availableHeight / DESIGN_HEIGHT;

//     const nextScale = Math.min(
//       widthScale,
//       heightScale,
//       1
//     );

//     setStageScale(nextScale);
//   };

//   updateStageScale();

//   const stage = stageRef.current;

//   let resizeObserver;

//   if (stage && typeof ResizeObserver !== 'undefined') {
//     resizeObserver = new ResizeObserver(() => {
//       updateStageScale();
//     });

//     resizeObserver.observe(stage);
//   }

//   window.addEventListener('resize', updateStageScale);
//   window.visualViewport?.addEventListener('resize', updateStageScale);

//   return () => {
//     resizeObserver?.disconnect();
//     window.removeEventListener('resize', updateStageScale);
//     window.visualViewport?.removeEventListener('resize', updateStageScale);
//   };
// }, []);

//     // ─── draw wheel ─────────────────────────────────────────────────────────────
//   const drawWheel = useCallback((segs, rotationDeg = 0) => {
//     const canvas = canvasRef.current;
//       if (!canvas || segs.length === 0) return;

//   const ctx = canvas.getContext('2d');
//   if (!ctx) return;

//   // =====================================================
//   // HIGH RESOLUTION CANVAS
//   // =====================================================

//   // Screen/device pixel ratio
//   const dpr = Math.min(window.devicePixelRatio || 1, 8);

//   // Wheel ka actual visible size
//   const size = wheelSize;

//   // Internal high-resolution pixel size
//   const pixelSize = Math.round(size * dpr);

//   // Canvas ki internal resolution high karo
//   if (canvas.width !== pixelSize || canvas.height !== pixelSize) {
//     canvas.width = pixelSize;
//     canvas.height = pixelSize;
//   }

//   // Canvas ka visible size same rakho
//   canvas.style.width = `${size}px`;
//   canvas.style.height = `${size}px`;

//   // Drawing ko DPR ke according scale karo
//   ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

//   const center = size / 2;
//   const radius = center - 1;
//   const SA = (2 * Math.PI) / segs.length;
//       ctx.clearRect(0, 0, size, size);
//       ctx.save();
//       ctx.translate(center, center);
//       ctx.rotate((rotationDeg * Math.PI) / 180);
//       ctx.translate(-center, -center);

//       segs.forEach((seg, i) => {
//         const sa  = i * SA - Math.PI / 2;
//         const ea  = sa + SA;
//         const bg  = wheelColors[i % wheelColors.length];
//         const ma  = sa + SA / 2;

//         ctx.beginPath();
//         ctx.moveTo(center, center);
//         ctx.arc(center, center, radius, sa, ea);
//         ctx.closePath();
//         ctx.fillStyle = bg;
//         ctx.fill();

//         const g = ctx.createRadialGradient(center, center, radius * 0.08, center, center, radius);
//         if (bg === '#FFFFFF') {
//           g.addColorStop(0,    'rgba(255,255,255,0.92)');
//           g.addColorStop(0.65, 'rgba(235,240,252,0.38)');
//           g.addColorStop(1,    'rgba(190,205,235,0.15)');
//         } else {
//           g.addColorStop(0,    'rgba(255,255,255,0.30)');
//           g.addColorStop(0.55, 'rgba(255,255,255,0)');
//           g.addColorStop(1,    'rgba(0,0,0,0.18)');
//         }
//         ctx.beginPath();
//         ctx.moveTo(center, center);
//         ctx.arc(center, center, radius, sa, ea);
//         ctx.closePath();
//         ctx.fillStyle = g;
//         ctx.fill();

//         ctx.beginPath();
//         ctx.moveTo(center, center);
//         ctx.lineTo(center + radius * Math.cos(sa), center + radius * Math.sin(sa));
//         ctx.strokeStyle = '#F1DA8B';
//         ctx.lineWidth   = 4;
//         ctx.stroke();

//         const isW = bg === '#FFFFFF';
//         ctx.save();
//         ctx.translate(
//           center + Math.cos(ma) * radius * 0.65,
//           center + Math.sin(ma) * radius * 0.65
//         );
//         ctx.rotate(ma);
//   const fontSize = size > 260 ? 18 : 14;

//   ctx.font = `900 ${fontSize}px "Century Gothic", "Arial Black", Arial, sans-serif`;

//         ctx.fillStyle   = isW ? '#111122' : '#FFFFFF';
//         ctx.textAlign   = 'center';
//         ctx.textBaseline = 'middle';

//         if (!isW) {
//           ctx.shadowColor   = 'rgba(0,0,0,0.6)';
//           ctx.shadowBlur    = 4;
//           ctx.shadowOffsetX = 0;
//           ctx.shadowOffsetY = 1;
//         }

//         // TEXT OVERFLOW FIX ADDED HERE (maxWidth as 4th parameter)
//         const maxTextWidth = radius * 0.70;
//         ctx.fillText(seg.label, 0, 0, maxTextWidth);
//         ctx.restore();
//       });

//     ctx.restore();
//   }, [wheelSize]);
//     useEffect(() => {
//       if (segments.length) {
//         segmentsRef.current = segments;
//         drawWheel(segments, currentAngleRef.current);
//       }
//   }, [segments, wheelSize, drawWheel]);
//     // ─── fetch products filtered by gender ──────────────────────────────────────
//     const fetchData = useCallback(async (currentGender) => {
//       setIsLoading(true);
//       try {
//         const res = await api.get(`${API_BASE}/api/products`, {
//           params: { gender: currentGender }
//         });

//         const active = Array.isArray(res.data)
//           ? res.data.filter(p => p.addInSpin === true)
//           : [];

//         if (active.length > 0) {
//           const mapped = active.map(p => {
//             const cfg = p.discounts?.length ? p.discounts[0] : null;
//             return {
//               label:        cfg ? cfg.label             : 'Try Again',
//               winWeight:    cfg ? Number(cfg.winWeight)  : 0,
//               categoryId:   p.id,
//               categoryName: p.category    || '',
//               subCategory:  p.subCategory || '',
//               gender:       p.gender      || currentGender,
//             };
//           });
//           setSegments([...mapped].sort(() => Math.random() - 0.5));
//         } else {
//           const fallback = currentGender === 'female'
//             ? DEFAULT_SEGMENTS_FEMALE
//             : DEFAULT_SEGMENTS_MALE;
//           setSegments([...fallback]);
//         }

//       } catch {
//         const fallback = currentGender === 'female'
//           ? DEFAULT_SEGMENTS_FEMALE
//           : DEFAULT_SEGMENTS_MALE;
//         setSegments([...fallback]);
//         showError('Could not load live data. Demo mode active.');
//       } finally {
//         setIsLoading(false);
//       }
//     }, [API_BASE]);

//     useEffect(() => {
//       if (rafRef.current) cancelAnimationFrame(rafRef.current);
//       stopSpeech();
//       setIsSpinning(false);
//       setShowCongrats(false);
//       setResult(null);
//       setWinningCode('');
//       currentAngleRef.current = 0;
//       fetchData(gender);
//     }, [gender, fetchData, stopSpeech]);

//     const resetWheelVisuals = () => {
//       setShowCongrats(false);
//       setResult(null);
//       setWinningCode('');
//       if (autoResetTimerRef.current) clearTimeout(autoResetTimerRef.current);
//       stopSpeech();
//     };

//     const canSpin = segments.length > 0 && !isLoading;
//     const spinDisabled = isSpinning || !canSpin || isLoading;


   

//     const checkMobileDuplicate = async (cleanMobile) => {
//       try {
//         const checkRes = await api.post(`${API_BASE}/api/spin/check-mobile`, {
//           mobileNumber: cleanMobile,
//         });
//         return checkRes.data;
//       } catch (err) {
//         if (err?.response?.data) return err.response.data;
//         if (err?.response?.status === 404) return { success: true, skipCheck: true };
//         throw err;
//       }
//     };

// // 🚫 CHECK BLOCKED NUMBER
// const checkBlockedNumber = async (cleanMobile) => {
//   try {
//     const response = await api.get(
//       `${API_BASE}/api/blocked-numbers/check`,
//       {
//         params: {
//           mobileNumber: cleanMobile,
//         },
//       }
//     );

//     return response.data;
//   } catch (err) {
//     if (err?.response?.data) {
//       return err.response.data;
//     }

//     throw err;
//   }
// };


//     // +92 hamesha save — 03xx → 923xx
//     const formatMobile = (raw) => {
//       let n = digitsOnly(raw);
//       if (n.startsWith('0')) n = '92' + n.slice(1);
//       if (!n.startsWith('92')) n = '92' + n;
//       return n;
//     };
// // 🚫 BLOCKED NUMBER POPUP HANDLER
// const showBlockedNumberPopup = () => {
//   setErrorMsg('');
//   setIsSpinning(false);
//   setShowBlockedPopup(true);
//   stopSpeech();
// };  
//    const handleSpin = async () => {
//     setErrorMsg('');

//     if (!playerName.trim()) return showError('Please enter your full name.');

//     const rawDigits = digitsOnly(mobileNumber);
//     if (rawDigits.length < 10 || rawDigits.length > 12) {
//       return showError(`Please enter a valid 10 or 11-digit mobile number.`);
//     }

//     if (!segmentsRef.current.length) return showError('Wheel is not ready yet. Please wait...');
//     if (isSpinning) return;
//     if (!canSpin) return showError('Wheel not ready. Please wait.');

//     const savedMobile = formatMobile(rawDigits);
//     // =========================================================
// // 🚫 BLOCKED NUMBER CHECK
// // Number BlockedNumber table mein hai to spin STOP
// // =========================================================
// try {
//   const blockedData = await checkBlockedNumber(savedMobile);

//   if (blockedData?.isBlocked === true) {
//     showBlockedNumberPopup();
//     return;
//   }
// } catch (err) {
//   return showError(
//     getApiErrorMessage(
//       err,
//       'Could not verify mobile number. Please try again.'
//     )
//   );
// }

//     // 1. Duplicate check (Specific Message Popup Added)
//     // 1. Duplicate check (Specific Message Popup Added)
//     try {
//       const checkData = await checkMobileDuplicate(savedMobile);
//       if (checkData?.success === false) {
//         if (checkData.isLimitReached) {
//             setPreviousWinData(checkData.previousWin || checkData.data || {
//               mobile: savedMobile,
//               prize: 'Discount Voucher',
//               subCategory: '',
//               code: 'N/A',
//               status: 'Sent',
//               validUntil: 'N/A'
//             });
//             setShowAlreadyUsedPopup(true);
//         } else {
//             return showError(checkData.error || 'Network error, please try again.');
//         }
//         return;
//       }
//     } catch (err) {
//       return showError(getApiErrorMessage(err));
//     } 

//     // 2. Call backend FIRST to get the winner
//     setIsSpinning(true);
//     let sr;
//     try {
//       sr = await api.post(`${API_BASE}/api/spin/result`, {
//         playerName: playerName.trim(),
//         countryCode,
//         mobileNumber: savedMobile,
//         gender,
//         storeId,
//       });
// // 🚫 BACKEND BLOCKED SAFETY CHECK
// if (sr.data?.isBlocked === true) {
//   showBlockedNumberPopup();
//   return;
// }
//       if (!sr.data.success) {
//         setIsSpinning(false);
//         // FIXED: Same yahan bhi condition update karni hai
//         if (sr.data.isLimitReached) {
//             setPreviousWinData(sr.data.previousWin || sr.data.data || null);
//             setShowAlreadyUsedPopup(true);
//         } else {
//             return showError(sr.data.error || 'Spin failed.');
//         }
//         return;
//       }
//    } catch (err) {
//   setIsSpinning(false);

//   // 🚫 BACKEND BLOCKED RESPONSE
//   if (err?.response?.data?.isBlocked === true) {
//     showBlockedNumberPopup();
//     return;
//   }

//   return showError(
//     getApiErrorMessage(
//       err,
//       'Spin failed.'
//     )
//   );
// }

//     // ... (Yahan se neechay ka animation aur result wala code same rahay ga) ...

//     // 3. Setup Animation to land on the winner
//     const segs = segmentsRef.current;
//     const targetIndex = segs.findIndex(s => String(s.categoryId) === String(sr.data.categoryId));
    
    

//     const sliceA = 360 / segs.length;
//     const wCenter = targetIndex * sliceA + sliceA / 2;
//     const DURATION = 20000; // 20 seconds
//     const curRot = currentAngleRef.current % 360;
//     const adj = (360 - (wCenter % 360)) % 360;
//     const target = currentAngleRef.current + (360 - curRot) + (360 * 25) + adj;
//     const startA = currentAngleRef.current;
//     const startT = performance.now();

//     lastTickTimeRef.current = startT;
//     playTickSound(1800, 0.018, 0.03);

//     let lastTickSlice = Math.floor(startA / sliceA);
//     const easeOut = t => 1 - Math.pow(1 - t, 5);

//     const animate = (now) => {
//       const prog = Math.min((now - startT) / DURATION, 1);
//       const cur = startA + (target - startA) * easeOut(prog);
//       currentAngleRef.current = cur;
//       drawWheel(segs, cur);

//       const currentSlice = Math.floor(cur / sliceA);
//       if (currentSlice > lastTickSlice) {
//         const remaining = 1 - prog;
//         const freq = remaining > 0.78 ? 1900 : remaining > 0.60 ? 1600 : 1300;
//         const gain = remaining > 0.78 ? 0.028 : 0.05;
//         playTickSound(freq, 0.14, gain);
//         lastTickSlice = currentSlice;
//       }

//       if (prog < 1) {
//         rafRef.current = requestAnimationFrame(animate);
//       } else {
//         currentAngleRef.current = target % 360;
//         drawWheel(segs, currentAngleRef.current);
//         setIsSpinning(false);

//         // 4. Show Congrats
//         const matchedSeg = segs[targetIndex];
//         const displayResult = {
//           label: sr.data.prizeLabel || matchedSeg?.label || '',
//           subCategory: sr.data.wonSubcategory || matchedSeg?.subCategory || '',
//           categoryName: matchedSeg?.categoryName || '',
//         };

//         setWinningCode(sr.data.generatedCode);
//         setResult(displayResult);
//         setShowCongrats(true);
//         speakText(`Congratulations! You have won ${displayResult.label} discount on ${displayResult.subCategory || 'shoes'}.`);
//         triggerConfetti();
//       }
//     };

//     rafRef.current = requestAnimationFrame(animate);
//   };

//    const redT   = Math.max(18, wheelSize * 0.082);
// const silT   = Math.max(4,  wheelSize * 0.018);
// const silD   = wheelSize + silT * 2;
// const outD   = silD + redT * 2;

// /* NEW: outer dark-brown ring */
// const outerBrownT = Math.max(10, wheelSize * 0.045);
// const outerBrownD = outD + outerBrownT * 2;

// /* Outer brown ring ke center par bulbs */
// const outerBrownBulbR = outD / 2 + outerBrownT / 2;

// const contD  = outerBrownD + (wheelSize > 200 ? 24 : 14);

// const silR   = silD / 2;
// const dH     = Math.max(14, silT * 7.0);
// const dW     = Math.max(9,  silT * 40 / 6.0);
// // === PURANAY dotAng AUR dotSz KO IN SE REPLACE KAREIN ===
// // === 18 BULBS AUR PERFECT LETAY HUE OVALS KE SIZES ===
//   const dotAng = Array.from({ length: 18 }, (_, i) => i * 20); // 18 lights (har 20 degree par)
//   const diaAng = [0, 45, 90, 135, 180, 225, 270, 315];
  
//   // W ko lamba aur H ko patla rakha hai taake capsule/leta hua oval bane
//   const bulbW  = Math.max(14, wheelSize * 0.055); // Lambai (Length)
//   const bulbH  = Math.max(6,  wheelSize * 0.015); // Motayi (Thickness)
//   const logoSz = Math.max(44, wheelSize * 0.24);  

//   /* =========================================================
//      CODE-ONLY GOLD PODIUM (NO IMAGE / NO LIBRARY)
//      ========================================================= */
//   const podiumH = Math.max(112, Math.min(150, wheelSize * 0.99));
// const podiumW = Math.min(420, Math.max(280, wheelSize * 1));
// const podiumVisualH = podiumW * 0.32;

// const wheelPodiumGap = 0;
// const stageH = contD + wheelPodiumGap + podiumVisualH;
// const responsiveViewportWidth =
//   window.visualViewport?.width || window.innerWidth;
// const responsiveFormWidth =
//   Math.min(360, responsiveViewportWidth * 0.92) /
//   Math.max(stageScale, 0.01);

//       return (
// <div
//   ref={stageRef}
//   style={{
//     height: 'calc(100dvh - -15px)',
//     width: '100%',
//     maxWidth: `${DESIGN_WIDTH}px`,
//     position: 'fixed',
//     top: '42px',
//     left: '50%',
//     transform: 'translateX(-50%)',
//     margin: 0,
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'flex-start',
//     zIndex: 1,
//     overflow: 'hidden',
//     padding: 0,
//     boxSizing: 'border-box',
//     isolation: 'isolate',
//   }}
// >
  
//     {/* 🔹 MIRRORED BACKGROUND LAYER 🔹 */}
// <div
//   style={{
//     position: 'absolute',
//     inset: 0,
//     width: '100%',
//     height: '100%',
//     zIndex: 0,
//     pointerEvents: 'none',
//     overflow: 'hidden',
//   }}
// >
//   <img
//   src={bgImage}
//   alt=""
//   style={{
//     position: 'absolute',
//     inset: 0,
//     width: '100%',
//     height: '100%',
//     display: 'block',
//     objectFit: 'fill',
//     objectPosition: 'center top',
//   }}
// />
// </div>




    
//         <style>
//           {` 
//             @keyframes crazyShake {
//               0% { transform: scale(1) skewY(-8deg) translate(0,0); }
//               25% { transform: scale(1.1) skewY(-8deg) translate(10px, -10px); }
//               50% { transform: scale(1.2) skewY(-8deg) translate(-10px, 10px); }
//               75% { transform: scale(1.1) skewY(-8deg) translate(10px, 10px); }
//               100% { transform: scale(1) skewY(-8deg) translate(0,0); }
//             }
//             @keyframes popIn{from{opacity:0;transform:scale(0.65) translateY(40px);}to{opacity:1;transform:scale(1) translateY(0);} }
//             @keyframes slideDown{from{opacity:0;transform:translateX(-50%) translateY(-30px);}to{opacity:1;transform:translateX(-50%) translateY(0);} }

//             @keyframes blink {
//               0%, 100% { opacity: 1; }
//               50% { opacity: 0; }
//             }

//             @keyframes podiumGlow {
//               from { opacity: 0.72; }
//               to { opacity: 1; }
//             }

//            .responsive-wrapper-card {
//   position: absolute;
//   inset: 0;
//   z-index: 5;
//   width: 100%;
//   max-width: 440px;
//   height: 100%;
//   padding: 0;
//   text-align: center;
//   display: block;
//   box-sizing: border-box;
// }

//          .responsive-flex-container {
//   position: absolute;
//   inset: 0;
//   width: 100%;
//   height: 100%;
//   margin: 0;
//   padding: 0;
// }

//             .responsive-form-box {
//               width: 100%;
//               max-width: 360px;
//               display: flex;
//               flex-direction: column;
//               gap: 3px;
//               margin-top: 2px;
//             }

//             @media (max-height: 760px) {
//               .responsive-wrapper-card {
//                 padding: 4  px 12px !important;
//               }
              
//               .responsive-form-box {
//                 gap: 3px !important;
//               }
//               h1 {
//                 font-size: 26px !important;
//               }
//             }

//             /* On short/narrow phones, pin the complete form above the visible
//                viewport bottom (the artboard itself starts 42px down and is 15px taller). */
//             @media (max-height: 760px), (max-width: 390px) {
//               .responsive-form-box {
//                 top: auto !important;
//                 bottom: calc(57px + max(8px, env(safe-area-inset-bottom))) !important;
//                 margin-top: 0 !important;
//               }
//             }
//           `}
//         </style>

//         {errorMsg && (
//           <div style={{
//             width:'90%', maxWidth:'500px',
//             margin:'0 auto 12px auto',
//             backgroundColor:'#C62828',
//             color:'white',
//             padding:'12px 18px',
//             borderRadius:'12px',
//             fontWeight:'bold',
//             fontSize:'14px',
//             fontFamily:'Arial, sans-serif',
//             boxShadow:'0 6px 20px rgba(0,0,0,0.45)',
//             textAlign:'center',
//             border:'2px solid rgba(255,215,0,0.6)',
//             lineHeight:1.4,
//             position:'relative',
//             zIndex:50
//           }}>
//             ⚠️ {errorMsg}
//           </div>
//         )}
//   <Participated
//   showAlreadyUsedPopup={showAlreadyUsedPopup}
//   onClose={() => setShowAlreadyUsedPopup(false)}
//   previousWinData={previousWinData}
//   mobileNumber={mobileNumber}
//   formatMobile={formatMobile}
// />



//       <div className="responsive-wrapper-card">
//           <div
//             style={{
//               marginTop: '0px',
//               marginBottom: '-30px', /* 100px ko 10px kar dein */
//               width: '100%',
//               textAlign: 'center',
//             }}
//           >
//           </div>

//            <div className="responsive-flex-container">
//                         <div
//   style={{
//     position: 'absolute',
//     left: '50%',
//     top: `calc(55% - ${stageH + 3 - (podiumVisualH / 2)}px)`,
//     transform: `translateX(-50%) scale(${stageScale})`,
//     transformOrigin: `50% ${stageH + 20}px`,
//     width: `${Math.min(430, Math.max(contD, podiumW))}px`,
//     height: `${stageH}px`,
//     zIndex: 10,
//     overflow: 'visible',
//   }}
// >
//               {/* =========================================================
//                   CODE-ONLY GOLD PODIUM / PEDESTAL
//                   Wheel sits directly on the top platform.
//                  ========================================================= */}
//       {/* ========================================================= 
//     CODE-ONLY PREMIUM GOLDEN PODIUM (SLIM & RESPONSIVE) 
//    ========================================================= */} 
// {/* ========================================================= 
//     CODE-ONLY PREMIUM GOLDEN PODIUM (BALANCED THICKNESS & GLOWING LIGHTS) 
//    ========================================================= */} 
// <div 
//   style={{ 
//     position: 'absolute', 
//     left: '50%', 
//     bottom: '-20px',  
//     transform: 'translateX(-50%)', 
//     width: `${225}px`,               // 👈 Responsive width (${podiumW})
//     height: `${podiumVisualH}px`,
//     zIndex: 2, 
//     pointerEvents: 'none', 
//   }} 
// > 
//   {/* 1. LOWER TIER - BODY */} 
//   <div style={{ 
//     position: 'absolute', 
//     bottom: 0, left: 0, 
//     width: '100%', 
//     height: `${podiumW * 0.15}px`,      // 👈 Lower tier ko thoda motta kiya (0.10 -> 0.15)
//     background: 'linear-gradient(90deg, #2b1101 0%, #7a450a 15%, #ffd76b 25%, #ffffff 28%, #ffd76b 32%, #b37414 45%, #422002 60%, #b37414 72%, #ffffff 80%, #ffd76b 83%, #7a450a 90%, #2b1101 100%)', 
//     borderRadius: `75% 75% 75% 75% / ${podiumW * 0.07}px ${podiumW * 0.07}px ${podiumW * 0.07}px ${podiumW * 0.07}px`,
//     borderBottom: '2px solid #fff3b0', 
//   }} /> 

//   {/* 2. LOWER TIER - TOP SURFACE & RIM LIGHTS */} 
//   <div style={{ 
//     position: 'absolute', 
//     bottom: `${podiumW * 0.06}px`, 
//     left: 0, 
//     width: '100%', 
//     height: `${podiumW * 0.12}px`,      // 👈 Surface ki thickness adjust ki
//     background: 'radial-gradient(ellipse at 50% 30%, #fffae0 0%, #ffcc4d 25%, #995c0f 65%, #381a01 100%)', 
//     borderRadius: '50%', 
//     border: '1.5px solid #ffe885', 
//   }}> 
//     {[ 
//       { top: '22%', left: '20%' }, { top: '26%', right: '20%' }, 
//       { bottom: '50%', left: '10%' }, { bottom: '41%', left: '30%' }, { bottom: '35%', left: '50%' }, 
//       { bottom: '40%', right: '30%' }, { bottom: '50%', right: '10%' }, 
//     ].map((pos, i) => ( 
//       <div key={`low-flare-${i}`} style={{ 
//         position: 'absolute',  
//         width: '6px',  
//         height: '3px',  
//         backgroundColor: '#ffffff', 
//         borderRadius: '50%',  
//         transform: 'translate(-50%, -50%)', 
//         boxShadow: '0 0 8px 3px #ffea8c, 0 0 14px 6px #d48806', // ✨ SHINING GLOW LIGHTS WAPAS ADD KAR DI
//         zIndex: 9,  
//         ...pos 
//       }} /> 
//     ))} 
//   </div> 

//   {/* 3. UPPER TIER - BODY */} 
//   <div style={{ 
//     position: 'absolute', 
//     bottom: `${podiumW * 0.10}px`,  
//     left: '13.5%', 
//     width: '75%', 
//     height: `${podiumW * 0.25}px`,      // 👈 Upper tier ko motta kiya (0.12 -> 0.25)
//     background: 'linear-gradient(90deg, #8b461b 0%, #7a450a 15%, #ffd76b 25%, #ffffff 28%, #ffd76b 32%, #b37414 45%, #422002 60%, #b37414 72%, #ffffff 80%, #ffd76b 83%, #7a450a 90%, #2b1101 100%)', 
//     borderRadius: `0 0 50% 50% / 0 0 ${podiumW * 0.75 * 0.07}px ${podiumW * 0.75 * 0.07}px`, 
//     borderBottom: '2px solid #fff3b0', 
//   }} /> 

//   {/* 4. UPPER TIER - TOP SURFACE */} 
//   <div style={{ 
//     position: 'absolute', 
//     bottom: `${podiumW * 0.16}px`,  
//     left: '13.5%', 
//     width: '75%', 
//     height: `${podiumW * 0.10}px`,      // 👈 Top surface thickness adjust ki
//     background: 'radial-gradient(ellipse at 50% 30%, #ffcc4d 0%, #ffcc4d 25%, #995c0f 65%, #381a01 100%)', 
//     borderRadius: '50%', 
//     border: '1.5px solid #ffe885', 
//   }}> 
//     {[ 
//       { top: '22%', left: '16%' },   
//       { top: '22%', right: '16%' },  
//     ].map((pos, i) => ( 
//       <div key={`up-flare-${i}`} style={{ 
//         position: 'absolute',  
//         width: '6px',  
//         height: '3px',  
//         backgroundColor: '#ede9cb', 
//         borderRadius: '50%',  
//         transform: 'translate(-50%, -50%)', 
//         boxShadow: '0 0 10px 4px #ffcc00, 0 0 20px 8px #ff6600', // ✨ SHINING GLOW LIGHTS WAPAS ADD KAR DI
//         zIndex: 3,  
//         ...pos 
//       }} /> 
//     ))} 
//   </div> 
// </div>
 
// {/* WHEEL STACK */} 
// <div style={{ 
//   position: 'absolute', top: 60, left: '50%', transform: 'translateX(-50%)', 
//   width: `${contD}px`, height: `${contD}px`, 
//   display: 'flex', justifyContent: 'center', alignItems: 'center', 
//   zIndex: 10, flexShrink: 0 
// }}>
//                  {/* =========================================================
//                     NEW DESIGN: OUTER BROWN RING + EXISTING GOLD RING
//                   ========================================================= */}
//                 <div
//                   style={{
//                     position: 'absolute',
//                     width: `${outerBrownD}px`,
//                     height: `${outerBrownD}px`,
//                     borderRadius: '50%',
//                     background: `radial-gradient(circle at 35% 30%, #6B3E0E 0%, #6B3E0E 28%, #6B3E0E 58%, #6B3E0E 100%)`,
//                     border: '2px solid #a06433',
//   filter: 'drop-shadow(0px 12px 14px rgba(61, 35, 35, 0.85))',
//       boxShadow: `inset 0 4px 6px #8A4812, inset 0 -7px 10px #8A4812`,
//                     zIndex: 10,
//                     clipPath: 'polygon(0% 0%, 500% 0%, 100% 93%, 85% 93%, 85% 100%, 15% 100%, 15% 93%, 0% 93%)'
//                   }}
//                 >
// {/* SOFT SHIMMER ANIMATION CSS (Bulb gayab nahi hoga, bas halka sa dim-bright hoga) */}
// <style>{`
//   @keyframes softCasinoPulse {
//     0%, 100% {
//       /* FULL GLOW - Tezz chamak */
//       opacity: 1;
//       background: #ffffff; 
//       box-shadow: 0 0 8px 3px #FFFF99, 0 0 18px 6px #FFD700, 0 0 26px 8px #FFA500;
//     }
//     50% {
//       /* HALKI GLOW - Bulb saaf nazar aayega, bas roshni thodi kam hogi */
//       opacity: 0.85;
//       background: #fefce8; 
//       box-shadow: 0 0 4px 1px #FFD700, 0 0 8px 3px rgba(255, 215, 0, 0.5); 
//     }
//   }
// `}</style>

// {/* BULBS ON BROWN RING */}
// {dotAng.map((deg, idx) => {
//   const r = (deg * Math.PI) / 180;
//   return (
//     <div
//       key={`outer-bulb-${idx}`}
//       style={{
//         position: 'absolute',
//         left: `${outerBrownD / 2 + Math.cos(r) * outerBrownBulbR - bulbW / 2}px`,
//         top: `${outerBrownD / 2 + Math.sin(r) * outerBrownBulbR - bulbH / 2}px`,
//         width: `${bulbW}px`,
//         height: `${bulbH}px`,
//         borderRadius: '50%',
//         background: '#efefcd',
//         transform: `rotate(${deg + 90}deg)`,
//         zIndex: 25,
//         pointerEvents: 'none',
        
//         // SOFT PULSING ANIMATION (Smooth aur halki blinking)
//         animation: 'softCasinoPulse 1.2s infinite ease-in-out alternate',
        
//         // Soft Alternating Timing
//         animationDelay: `${(idx % 2) * 0.6}s` 
//       }}
//     />
//   );
// })}

//                   {/* EXISTING METALLIC GOLD RING */}
//                   <div
//                     style={{
//                       position: 'absolute',
//                       left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
//                       width: `${outD}px`, height: `${outD}px`,
//                       borderRadius: '50%',
//                       background: 'conic-gradient(from 0deg, #CE954C 0%, #D4962A 20%, #CE954C 40%, #CE954C 60%, #D4962A 80%, #CE954C 100%)',
//                       boxShadow: `inset 0 3px 6px rgba(255,255,255,0.8), inset 0 -4px 8px rgba(0,0,0,0.7)`,
//                       border: '2px solid #D4962A',
//                       zIndex: 11,
//                       pointerEvents: 'none'
//                     }}
//                   >
//                     {/* EXISTING INNER DARK-BROWN RING WITH DIAMONDS */}
//                     <div
//                       style={{
//                         position: 'absolute',
//                         left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
//                         width: `${silD}px`, height: `${silD}px`,
//                         borderRadius: '50%',
//                         background: 'radial-gradient(circle, #944C13 0%, #3B1B04 100%)',
//                         boxShadow: 'inset 0 0 8px rgba(0,0,0,0.9), 0 0 0 2px #CF943F',
//                         zIndex: 12,
//                         pointerEvents: 'none'
//                       }}
//                     >
//                       {diaAng.map((deg, idx) => {
//                         const r = (deg * Math.PI) / 180;
//                         return (
//                           <div
//                             key={`diamond-${idx}`}
//                             style={{
//                               position: 'absolute',
//                               left: `${silD / 2 + Math.cos(r) * silR - dW / 2}px`,
//                               top: `${silD / 2 + Math.sin(r) * silR - dH / 2}px`,
//                               width: `${dW}px`, height: `${dH}px`,
//                               zIndex: 13,
//                               pointerEvents: 'none'
//                             }}
//                           >
//                             <svg width={dW} height={dH} viewBox="0 0 15 38" style={{ transform: `rotate(${deg}deg)` }}>
//                               <path d="M12 1 L23 19 L12 37 L1 19 Z" fill="#4B290E" stroke="#4B290E" strokeWidth="1.2" />
//                             </svg>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>

//               <canvas
              
//     ref={canvasRef}
//     style={{
//       position: 'absolute',
//       width: `${wheelSize}px`,
//       height: `${wheelSize}px`,
//       borderRadius: '50%',
//       zIndex: 20,
//       display: 'block'
//     }}
//   />

//              <div
//   onClick={() => { if (!spinDisabled) handleSpin(); }}
//   style={{
//     position: 'absolute',
//     width: `${logoSz}px`,
//     height: `${logoSz}px`,
//     borderRadius: '50%',
//     background: '#D49D43',
//     boxShadow: '0 3px 8px rgba(0,0,0,0.25)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     zIndex: 30,
//     cursor: spinDisabled ? 'default' : 'pointer'
//   }}
// >
//   <span
//     style={{
//       fontWeight: 900,
//       fontSize: `${Math.max(10, wheelSize * 0.045)}px`,
//       fontFamily: '"Century Gothic", sans-serif',
//       color: '#ffffff',
//       letterSpacing: '2px'
//     }}
//   > 
//     LOGO
//   </span>
// </div>

            
// <div style={{
//   position:'absolute', top:`${(contD - outD) / 2 - 28}px`, left:'50%',
//   transform:'translateX(-50%)', zIndex:100, overflow:'visible',
//   filter:`drop-shadow(0px 3px 4px rgba(0,0,0,0.55)) drop-shadow(0px 0px 9px rgba(255,190,50,0.32))`,
//   pointerEvents:'none',
// }}>
//   <svg width="45" height="60" viewBox="0 0 60 80" fill="none"
//     xmlns="http://www.w3.org/2000/svg" style={{overflow:'visible',display:'block'}}>
//     <defs>
//       {/* Main metallic gold */}
//       <linearGradient id="pointerGold" x1="5" y1="5" x2="55" y2="75" gradientUnits="userSpaceOnUse">
//         <stop offset="0%" stopColor="#FFF8D7"/><stop offset="14%" stopColor="#FFE99A"/><stop offset="32%" stopColor="#F6D16A"/>
//         <stop offset="52%" stopColor="#DFA83F"/><stop offset="72%" stopColor="#B9791D"/><stop offset="88%" stopColor="#F0C75A"/><stop offset="100%" stopColor="#FFF0AD"/>
//       </linearGradient>
//       {/* Inner warm gold */}
//       <linearGradient id="pointerInnerGold" x1="13" y1="12" x2="48" y2="68" gradientUnits="userSpaceOnUse">
//         <stop offset="0%" stopColor="#FFF3B8"/><stop offset="35%" stopColor="#E4B44D"/><stop offset="65%" stopColor="#C58A28"/><stop offset="100%" stopColor="#F4D06A"/>
//       </linearGradient>
//       {/* Bright center highlight */}
//       <radialGradient id="pointerGlow" cx="50%" cy="35%" r="65%"><stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.95"/><stop offset="25%" stopColor="#FFF4B8" stopOpacity="0.9"/><stop offset="55%" stopColor="#FFD65A" stopOpacity="0.35"/><stop offset="100%" stopColor="#FFD65A" stopOpacity="0"/></radialGradient>
//       {/* Hole gradient */}
//       <radialGradient id="pointerHole" cx="35%" cy="30%" r="70%"><stop offset="0%" stopColor="#4B2B0C"/><stop offset="55%" stopColor="#241204"/><stop offset="100%" stopColor="#0C0703"/></radialGradient>
//       {/* Outer shadow */}
//       <filter id="pointerShadow" x="-50%" y="-50%" width="200%" height="220%"><feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="#4E2607" floodOpacity="0.75"/></filter>
//       {/* Golden glow */}
//       <filter id="pointerLight" x="-100%" y="-100%" width="300%" height="300%"><feGaussianBlur stdDeviation="3" result="blur"/></filter>
//       {/* Tip glow */}
//       <filter id="tipGlow" x="-200%" y="-200%" width="400%" height="400%"><feGaussianBlur stdDeviation="2" result="glow"/></filter>
//       {/* Soft highlight */}
//       <linearGradient id="pointerShine" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.85"/><stop offset="35%" stopColor="#FFF4C4" stopOpacity="0.45"/><stop offset="100%" stopColor="#FFFFFF" stopOpacity="0"/></linearGradient>
//     </defs>
//     {/* ================================================= SOFT GOLDEN LIGHT BEHIND POINTER ================================================= */}
//     <path d="M30 5 C14 5 4 17 4 32 C4 45 20 65 26 74 C28 77 32 77 34 74 C40 65 56 45 56 32 C56 17 46 5 30 5 Z" fill="#FFD45A" opacity="0.22" filter="url(#pointerLight)"/>
//     {/* ================================================= MAIN POINTER BODY ================================================= */}
//     <path d="M30 8 C16 8 6 18 6 32 C6 44 22 64 27 71 C28.5 73 31.5 73 33 71 C38 64 54 44 54 32 C54 18 44 8 30 8 Z" fill="url(#pointerGold)" stroke="#6E3B0D" strokeWidth="3" strokeLinejoin="round" filter="url(#pointerShadow)"/>
//     {/* ================================================= THIN INNER LIGHT-BROWN / GOLD BORDER ================================================= */}
//     <path d="M30 11 C18 11 9.5 20.2 9.5 32 C9.5 42.5 24 61.5 28.8 68.3 C29.4 69.2 30.6 69.2 31.2 68.3 C36 61.5 50.5 42.5 50.5 32 C50.5 20.2 42 11 30 11 Z" fill="none" stroke="#F8DC8A" strokeWidth="1.2" opacity="0.95"/>
//     {/* ================================================= INNER GOLD SHADING ================================================= */}
//     <path d="M30 13 C20 13 11.5 21.5 11.5 32 C11.5 41.5 24.5 58.5 29 65 C29.5 65.8 30.5 65.8 31 65 C35.5 58.5 48.5 41.5 48.5 32 C48.5 21.5 40 13 30 13 Z" fill="url(#pointerInnerGold)" opacity="0.32"/>
//     {/* ================================================= METALLIC SHINE ON LEFT SIDE ================================================= */}
//     <path d="M13 28 C14 19 21 13 28 12 C23 19 20 29 21 39 C21.5 46 24 54 27 60 C20 51 14 40 13 28 Z" fill="url(#pointerShine)" opacity="0.8"/>
//     {/* ================================================= SMALL BRIGHT SHINE ================================================= */}
//     <path d="M17 23 C20 17 25 14 30 14" stroke="#FFFFFF" strokeWidth="1.4" strokeLinecap="round" opacity="0.55"/>
//     {/* ================================================= CENTER / TOP HOLE ================================================= */}
//     <circle cx="30" cy="30" r="11" fill="#FFD75C" opacity="0.24" filter="url(#pointerLight)"/>
//     <circle cx="30" cy="30" r="7.3" fill="url(#pointerHole)" stroke="#5D330D" strokeWidth="1.3"/>
//     <ellipse cx="27.5" cy="27.2" rx="2.1" ry="1.3" fill="#FFF1B4" opacity="0.32"/>
//     {/* ================================================= INTENSE SPARKLE / LENS FLARE AT THE TIP ================================================= */}
//     {/* Outer soft glow */}
//     <circle cx="30" cy="67" r="8" fill="#FFE58F" opacity="0.45" filter="url(#tipGlow)"/>
//     {/* Vertical light streak */}
//     <ellipse cx="30" cy="67" rx="1.2" ry="6.5" fill="#FFFFFF" opacity="0.95" filter="url(#tipGlow)"/>
//     {/* Horizontal light streak */}
//     <ellipse cx="30" cy="67" rx="6.5" ry="1.2" fill="#FFFFFF" opacity="0.95" filter="url(#tipGlow)"/>
//     {/* Bright center diamond core */}
//     <circle cx="30" cy="67" r="2" fill="#FFFFFF" opacity="1"/>
//   </svg>
// </div>
// </div>
// </div>

//         <div
//   className="responsive-form-box"
//   style={{
//     position: 'absolute',
//     left: '50%',

//     // PODIUM ke bilkul 3px neeche
//     top: `calc(65% + ${(podiumVisualH / 2) + 50}px)`,

//     transform: `translateX(-50%) scale(${stageScale})`,
//     transformOrigin: 'bottom center',

//     width: `${responsiveFormWidth}px`,
//     maxWidth: 'none',

//     display: 'flex',
//     flexDirection: 'column',
// alignItems: 'center',
//     gap: '2px',

//     zIndex: 50,
//     boxSizing: 'border-box',

//     // Neeche complete form visible rakhne ke liye
//   }}
// >
//               <div
//                 style={{
//                   display: 'flex',
//                   gap: '3px',
//                   justifyContent: 'center',
//                   width: '60%'
//                 }}
//               >
//                 <button
//                   type="button"
//                   onClick={() => { if (!isSpinning) setGender('male'); }}
//                   disabled={isSpinning}
//                   style={{
//                     flex: 1,
//                     padding: '1px 0',
//                     borderRadius: '36px',
//                     border: 'none',
//                     fontWeight: 'bold',
//                     fontSize: '13px',
//                     cursor: isSpinning ? 'not-allowed' : 'pointer',
//                     background: gender === 'male' ? 'linear-gradient(135deg, #B58632, #F6DD7C)' : '#f0f0f0',
//                     color: gender === 'male' ? '#503314' : '#503314',
//                     boxShadow: gender === 'male' ? '0 4px 12px rgba(30,136,229,0.4)' : 'none',
//                     transition: 'all 0.2s ease',
//                     boxSizing: 'border-box'
//                   }}
//                 >
//                   ♂ Male
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => { if (!isSpinning) setGender('female'); }}
//                   disabled={isSpinning}
//                   style={{
//                     flex: 1,
//                     padding: '4px 0',
//                     borderRadius: '36px',
//                     border: 'none',
//                     fontWeight: 'bold',
//                     fontSize: '13px',
//                     cursor: isSpinning ? 'not-allowed' : 'pointer',
//                     background: gender === 'female' ? 'linear-gradient(135deg, #B58632, #F6DD7C)' : '#f0f0f0',
//                     color: gender === 'female' ? '#503314' : '#503314',
//                     boxShadow: gender === 'female' ? '0 4px 12px rgba(233,30,99,0.4)' : 'none',
//                     transition: 'all 0.2s ease',
//                     boxSizing: 'border-box'
//                   }}
//                 >
//                   ♀ Female
//                 </button>
//               </div>

//               <input
//                 type="text"
//                 placeholder="Your full name"
//                 style={{
//                   width: '60%',
//                   height: '30px',
//                   padding: '0 12px',
//                   borderRadius: '10px',
//                   border: 'none',
//                   boxSizing: 'border-box',
//                   fontSize: '13px',
//                   outline: 'none',
//                   boxShadow: '0 3px 10px rgba(0,0,0,0.14)',
//                   margin: 0
//                 }}
//                 value={playerName}
//                 onChange={e => setPlayerName(e.target.value)}
//                 disabled={spinDisabled}
//               />

//               <div
//                 style={{
//                   display: 'flex',
//                   gap: '1px', 
//                   width: '60%',            
//                   boxSizing: 'border-box'
//                 }}
//               >
//                 <select
//                   value={countryCode}
//                   onChange={e => setCountryCode(e.target.value)}
//                   style={{
//                     width: '35px', 
//                     height: '30px', 
//                     padding: '0 0 0 6px', 
//                     borderRadius: '10px',
//                     border: 'none',
//                     fontSize: '12px', 
//                     boxShadow: '0 3px 10px rgba(0,0,0,0.14)',
//                     boxSizing: 'border-box',
//                     margin: 0,
//                     backgroundColor: '#fff',
//                     flexShrink: 0,
//                     cursor: 'pointer',
//                     appearance: 'none', 
//                     WebkitAppearance: 'none'
//                   }}
//                   disabled={spinDisabled}
//                 >
//                   <option value="PK">+92</option>
//                   <option value="AE">+971</option>
//                 </select>
//                 <input
//                   type="tel"
//                   placeholder="3023456789"
//                   maxLength={10}
//                   style={{
//                     flex: 1,
//                     minWidth: '0',
//                     height: '30px',
//                     padding: '0 14px',
//                     borderRadius: '10px',
//                     border: 'none',
//                     fontSize: '14px',
//                     outline: 'none',
//                     boxShadow: '0 1px 10px rgba(0,0,0,0.14)',
//                     boxSizing: 'border-box',
//                     margin: 0,
//                     fontFamily: 'inherit'
//                   }}
//                   value={mobileNumber}
//                   onChange={e => setMobileNumber(e.target.value.replace(/\D/g,'').slice(0,12))}
//                   disabled={spinDisabled}
//                 />
//               </div>

//               <button
//                 onClick={handleSpin}
//                 disabled={spinDisabled}
//                 style={{  
//                   width: '60%',
//                   minHeight: 'clamp(30px, 5vh, 36px)',
//                   padding: '0 clamp(10px, 3vw, 16px)',
//                   borderRadius: '10px',
//                   border: 'none',
//                   background: spinDisabled
//                     ? '#6e6e6e'
//                     : 'linear-gradient(180deg,#F6DD7C 0%,#BC8F39 45%,#F6DD7C 100%)',
//                   color: '#503314',
//                   fontWeight: 900,
//                   cursor: spinDisabled ? 'not-allowed' : 'pointer',
//                   fontSize: 'clamp(13px, 3.5vw, 15px)',
//                   lineHeight: 1,
//                   letterSpacing: 'clamp(0.6px, 0.2vw, 1px)',
//                   transition: 'all 0.3s ease',
//                   fontFamily: "'Arial Black',Arial,sans-serif",
//                   boxShadow: spinDisabled ? 'none' : '0 4px 12px rgba(229,57,53,0.42)',
//                   boxSizing: 'border-box',
//                   margin: 0,
//                   whiteSpace: 'nowrap',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                 }}
//               >
//                 {isLoading
//                   ? 'LOADING...'
//                   : isSpinning
//                     ? '• SPINNING... •'
//                     : '• SPIN NOW •'}
//               </button>
//             </div>
//           </div>
//         </div>

//           <Congratulations
//         showCongrats={showCongrats}
//         result={result}
//         winningCode={winningCode}
//         onClose={resetWheelVisuals}
//       />
//     </div>
//   );
// }
